import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Avatar,
  Box,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Fab,
  List,
  ListItem,
  ListItemText,
  Modal,
  Tooltip,
  Typography,
  Menu,
  Slider,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { decode } from "base-64";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useMode } from "../theme";
// import useApiPrivate from '../auth/useApiPrivate';
import { CheckCircle, ExpandMore } from "@mui/icons-material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import BalanceIcon from "@mui/icons-material/Balance";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import VerifiedIcon from "@mui/icons-material/Verified";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { useFormik } from "formik";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import KPeeLogo from "../LogoKPee1.png";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import { FormatedDate } from "../components/SavingsDetails";
import "./../working.css";
import MainAccounts from "./MainAccounts";
import SocietyWarehouse from "./SocietyWarehouse";
import CachedRoundedIcon from "@mui/icons-material/CachedRounded";
import { useNavigate } from "react-router-dom";
import BankRecon from "../components/BankRecon";
import DailyBankRecon from "../components/DailyBankRecon";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const FormatedDateNoTime = ({ value }) => {
  const date = new Date(value);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  return <span>{formattedDate}</span>;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const options = ["Reconciled", "Pending"];

const Reconcile = ({ one, fetchWhyWeAreHere }) => {
  const [note, setNote] = useState(false);
  const [chats, setChats] = useState([]);
  const [RecoMessage, setReconMessage] = useState("");
  const [noteInfo, setNoteInfo] = useState("");
  const [stat] = useState(
    one.momo_bal - one.cash_value !== null ? "Conflict" : "Balanced"
  );
  const { permissions } = useContext(AuthContext);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  // Pending Button
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const oppen = Boolean(anchorEl);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  // console.log(open)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClosee = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloses = () => {
    setAnchorEl(null);
  };
  // const [num, setNum] = useState(null)

  const handleDone = (event) => {
    event.preventDefault();
    const datara = {
      status: stat,
      note: noteInfo,
      momo_id: one.mid,
      message: RecoMessage,
    };
    api
      .post("/association/edit/reconciliation", datara, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setNoteInfo("");
          setReconMessage("");
          callar();
          fetchWhyWeAreHere();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const callar = () => {
    api
      .get(`/association/reconciled/note/${one.mid}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setNoteInfo(response.data?.Note);
        setChats(response.data?.Chats);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleReconciliation = () => {
    callar();
    setNote(true);
  };

  const handleClose = () => {
    setNote(false);
  };

  const handleNoteChange = (event) => {
    setNoteInfo(event.target.value);
  };
  const handleReconMessageChange = (event) => {
    setReconMessage(event.target.value);
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const saveHandle = () => {
    toast.promise(
      api.post(
        "/association/set/button",
        {
          momo_id: one.mid,
          cash_id: one.cid,
          button: options[selectedIndex],
        },
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }
      ),
      {
        loading: "Reconciling...",
        success: (res) => {
          fetchWhyWeAreHere();
          return `Set to ${options[selectedIndex]}`;
        },
        error: (err) => {
          console.log(err);
          return "An error occurred";
        },
      }
    );
  };

  const memoizedChats = useMemo(() => {
    return chats.map((item, index) => (
      <Grid item key={index} xs={12} md={12}>
        <Typography>
          {item.username}: {item.message}
        </Typography>
      </Grid>
    ));
  }, [chats]);

  if (permissions && permissions.reconcile_balances === true) {
    return (
      <>
        <ButtonGroup
          size="small"
          ref={anchorRef}
          sx={{ marginRight: 9 }}
          aria-label="split button"
        >
          <Button
            sx={{
              borderRadius: 7,
              backgroundColor:
                one.button === "Pending"
                  ? "#d90429"
                  : one.button === "Reconcile"
                  ? "#155d27"
                  : "#03045e",
              color: "#fff",
              boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
              minWidth: 0,
              "&:hover": {
                boxShadow:
                  "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={handleReconciliation}
            startIcon={
              one.button === "Reconcile" ? (
                <HandshakeOutlinedIcon />
              ) : one.button === "Pending" ? (
                <PendingActionsRoundedIcon />
              ) : (
                <VerifiedIcon />
              )
            }
          >
            {options[selectedIndex] ? options[selectedIndex] : one.button}
          </Button>
          <IconButton onClick={saveHandle}>
            <SaveIcon />
          </IconButton>
          <Button
            variant="contained"
            size="small"
            sx={{
              borderRadius: 7,
              backgroundColor:
                one.button === "Pending"
                  ? "#d90429"
                  : one.button === "Reconcile"
                  ? "#155d27"
                  : "#03045e",
              color: "#fff",
              boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
              minWidth: 0,
              "&:hover": {
                boxShadow:
                  "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
              },
            }}
            id="demo-positioned-button"
            aria-controls={oppen ? "demo-positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={oppen ? "true" : undefined}
            onClick={handleClick}
          >
            <ArrowDropDownIcon />
          </Button>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={oppen}
            onClose={handleCloses}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {options.map((item, index) => (
              <MenuItem onClick={(e) => handleMenuItemClick(e, index)}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>{item}</b>
                </Typography>
              </MenuItem>
            ))}
            <MenuItem onClick={handleCloses}>
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Cancel</b>
              </Typography>
            </MenuItem>
          </Menu>
        </ButtonGroup>

        {/* <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClosee}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        // disabled={index === 2}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper> */}

        <Dialog open={note} onClose={handleClose}>
          <form onSubmit={handleDone}>
            <DialogTitle>Reconciliation Statement</DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Accordion sx={{ borderRadius: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        subtitle="h5"
                        sx={{ color: "black" }}
                      >
                        <b>View Details</b>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={1}>
                        <Grid item xs={6} md={6}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {formatDateToYearMonthDay(new Date(one.cdate))}
                            </b>
                          </Typography>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Cash Deposits:{" "}
                              {currencyFormat.format(one.cash_value)}
                            </b>
                          </Typography>
                        </Grid>

                        <Grid item xs={6} md={6}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {formatDateToYearMonthDay(new Date(one.mdate))}
                            </b>
                          </Typography>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Momo Deposits:{" "}
                              {currencyFormat.format(one.momo_bal)}
                            </b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Difference:{" "}
                              {currencyFormat.format(
                                one.momo_bal - one.cash_value
                              )}
                            </b>
                          </Typography>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
              <TextField
                autoFocus
                required
                margin="dense"
                id="noteInfo"
                label="Note"
                type="text"
                fullWidth
                sx={{ marginBottom: 2 }}
                variant="standard"
                value={noteInfo}
                onChange={handleNoteChange}
              />
              <DialogContentText>
                Chats on reconciliation status
              </DialogContentText>
              {memoizedChats}
              <TextField
                placeholder="type something here...."
                variant="outlined"
                sx={{ borderRadius: 15, textAlign: "center" }}
                fullWidth
                value={RecoMessage}
                onChange={handleReconMessageChange}
              />
            </DialogContent>
            <DialogActions
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Button onClick={handleClose} variant="contained" color="error">
                Cancel
              </Button>
              <Fab
                component="button"
                type="submit"
                color="success"
                size="medium"
                aria-label="add"
              >
                <SendIcon size="small" />
              </Fab>
            </DialogActions>
          </form>
        </Dialog>
      </>
    );
  } else {
    return null;
  }
};

const Clusters_reconcile = ({ one, fetchWhyWeAreHere }) => {
  const [note, setNote] = useState(false);
  const [chats, setChats] = useState([]);
  const [RecoMessage, setReconMessage] = useState("");
  const [noteInfo, setNoteInfo] = useState(one.note);
  const [stat] = useState(
    one.momo - one.cash !== null ? "Conflict" : "Balanced"
  );
  const { permissions } = useContext(AuthContext);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  // Pending Button
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const oppen = Boolean(anchorEl);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  // console.log(open)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClosee = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloses = () => {
    setAnchorEl(null);
  };
  // const [num, setNum] = useState(null)

  const handleDone = (event) => {
    event.preventDefault();
    const datara = new FormData();
    datara.append("cluster_id", one.cluster_id);
    datara.append("note", noteInfo);
    datara.append("date", one.date);

    toast.promise(
      api.post("/association/save/cluster/reconciliations/note", datara, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (res) => {
          setNote(false);
          fetchWhyWeAreHere();
          return "Note saved";
        },
        error: (err) => {
          console.log(err);
          return "An error occurred";
        },
      }
    );
  };

  const handleReconciliation = () => {
    setNote(true);
  };

  const handleClose = () => {
    setNote(false);
  };

  const handleNoteChange = (event) => {
    setNoteInfo(event.target.value);
  };
  const handleReconMessageChange = (event) => {
    setReconMessage(event.target.value);
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const saveHandle = () => {
    const data = new FormData();
    data.append("cluster_id", one.cluster_id);
    data.append("date", one.date);
    data.append(
      "status",
      options[selectedIndex] ? options[selectedIndex] : "Reconcile"
    );
    toast.promise(
      api.post("/association/save/cluster/reconciliations", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (res) => {
          fetchWhyWeAreHere();
          return `Set to ${
            options[selectedIndex]
              ? options[selectedIndex]
              : "Reconcile (default)"
          }`;
        },
        error: (err) => {
          console.log(err);
          return "An error occurred";
        },
      }
    );
  };

  const memoizedChats = useMemo(() => {
    return chats.map((item, index) => (
      <Grid item key={index} xs={12} md={12}>
        <Typography>
          {item.username}: {item.message}
        </Typography>
      </Grid>
    ));
  }, [chats]);

  if (permissions && permissions.reconcile_balances === true) {
    return (
      <>
        <ButtonGroup
          size="small"
          ref={anchorRef}
          sx={{ marginRight: 9 }}
          aria-label="split button"
        >
          <Button
            sx={{
              borderRadius: 7,
              backgroundColor:
                one.status === "Pending"
                  ? "#d90429"
                  : one.status === "Reconcile"
                  ? "#155d27"
                  : "#03045e",
              color: "#fff",
              boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
              minWidth: 0,
              "&:hover": {
                boxShadow:
                  "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
              },
            }}
            onClick={handleReconciliation}
            startIcon={
              one.status === "Reconcile" ? (
                <HandshakeOutlinedIcon />
              ) : one.status === "Pending" ? (
                <PendingActionsRoundedIcon />
              ) : (
                <VerifiedIcon />
              )
            }
          >
            {options[selectedIndex] ? options[selectedIndex] : one.status}
          </Button>
          <IconButton onClick={saveHandle}>
            <SaveIcon />
          </IconButton>
          <Button
            variant="contained"
            size="small"
            sx={{
              borderRadius: 7,
              backgroundColor:
                one.status === "Pending"
                  ? "#d90429"
                  : one.status === "Reconcile"
                  ? "#155d27"
                  : "#03045e",
              color: "#fff",
              boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
              minWidth: 0,
              "&:hover": {
                boxShadow:
                  "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
              },
            }}
            id="demo-positioned-button"
            aria-controls={oppen ? "demo-positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={oppen ? "true" : undefined}
            onClick={handleClick}
          >
            <ArrowDropDownIcon />
          </Button>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={oppen}
            onClose={handleCloses}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {options.map((item, index) => (
              <MenuItem onClick={(e) => handleMenuItemClick(e, index)}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>{item}</b>
                </Typography>
              </MenuItem>
            ))}
            <MenuItem onClick={handleCloses}>
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Cancel</b>
              </Typography>
            </MenuItem>
          </Menu>
        </ButtonGroup>

        <Dialog open={note} onClose={handleClose}>
          <form onSubmit={handleDone}>
            <DialogTitle>Reconciliation Statement</DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Accordion sx={{ borderRadius: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        subtitle="h5"
                        sx={{ color: "black" }}
                      >
                        <b>View Details</b>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {formatDateToYearMonthDay(new Date(one.date))}
                            </b>
                          </Typography>
                          <Box sx={{ display: "flex" }}>
                            <Box sx={{ m: 1, mr: "auto" }}>
                              <Typography
                                sx={{ textAlign: "center" }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>
                                  Cash Deposits:{" "}
                                  {currencyFormat.format(one.cash)}
                                </b>
                              </Typography>
                            </Box>
                            <Box sx={{ m: 1 }}>
                              <Typography
                                sx={{ textAlign: "center" }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>
                                  Momo Deposits:{" "}
                                  {currencyFormat.format(one.momo)}
                                </b>
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Difference:{" "}
                              {currencyFormat.format(one.momo - one.cash)}
                            </b>
                          </Typography>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
              <TextField
                autoFocus
                required
                margin="dense"
                id="noteInfo"
                label="Note"
                type="text"
                fullWidth
                sx={{ marginBottom: 2 }}
                variant="standard"
                value={noteInfo}
                onChange={handleNoteChange}
              />
              {/* <DialogContentText>
                Chats on reconciliation status
              </DialogContentText>
              {memoizedChats}
              <TextField
                placeholder="type something here...."
                variant="outlined"
                sx={{ borderRadius: 15, textAlign: "center" }}
                fullWidth
                value={RecoMessage}
                onChange={handleReconMessageChange}
              /> */}
            </DialogContent>
            <DialogActions
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Button onClick={handleClose} variant="contained" color="error">
                Cancel
              </Button>
              <Fab
                component="button"
                type="submit"
                color="success"
                size="medium"
                aria-label="add"
              >
                <SendIcon size="small" />
              </Fab>
            </DialogActions>
          </form>
        </Dialog>
      </>
    );
  } else {
    return null;
  }
};

export const AccountReconciliation = (props) => {
  const [data, setData] = useState([]);
  const [data_sec, setData_sec] = useState([]);
  const [clus_data, setClus_data] = useState([]);
  const [table_momo, setTable_momo] = useState(0);
  const [table_cash, setTable_cash] = useState(0);
  const [clus_or_asso, setClus_or_asso] = useState(false);
  const [from, setFrom] = useState("");
  const [matched, setMatched] = useState(null);
  const [fil_status, setFil_status] = useState(null);
  const [to, setTo] = useState("");
  const [alert, setAlert] = useState();
  const [deep, setDeep] = useState(false);
  const { permissions } = useContext(AuthContext);
  const [open_modal, setOpen_modal] = useState(false);
  const [selected_cid, setSelected_cid] = useState(null);
  const [selected_cdate, setSelected_cdate] = useState();
  const [selected_mdate, setSelected_mdate] = useState();
  const [selected_taken, setSelected_taken] = useState();
  const [selected_association_name, setSelected_association_name] =
    useState("");
  const [selected_cash_value, setSelected_cash_value] = useState(null);
  const [selected_momo_bal, setSelected_momo_bal] = useState(null);
  const [momo_for_rematch, setMomo_for_rematch] = useState([]);
  const [rematch_reason, setRematch_reason] = useState("");
  const [filter_datematch, setFilter_datematch] = useState();
  const [rematched_date, setRematched_date] = useState();
  const [rematched_momo_bal, setRematched_momo_bal] = useState(null);
  const [association_search, setAssociation_search] = useState(0);
  const [association_search_name, setAssociation_search_name] = useState("");
  const [cluster_search, setCluster_search] = useState(0);
  const [cluster_search_name, setCluster_search_name] = useState("");
  const [all_assos, setAll_assos] = useState([]);
  const [all_cluss, setAll_cluss] = useState([]);
  const [investor_deposits, setInvestor_deposits] = useState([]);
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);
  const [value2, setValue2] = useState(0);
  const [hold_view, setHold_view] = useState([]);
  const [investor_modal, setInvestor_Modal] = useState(false);
  const [openn, setOpenn] = React.useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [cashToDelete, setCashToDelete] = useState(null);
  const [personaInfo, setPersonaInfo] = useState([]);
  const [ao, setAo] = useState({});

  const filteredData = useMemo(() => {
    const uniqueData = Array.from(
      new Map(data_sec.map(item => [item.cid, item])).values()
    );
    
    // Then filter out rows where both cash_value and momo_bal are 0
    return Array.from(uniqueData).filter(item => 
      !(item.cash_value === 0 && item.momo_bal === 0)
    );
  }, [data_sec]);

  const handleDeleteClick = (cash_id) => {
    setCashToDelete(cash_id);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (cashToDelete) {
      deleteCash(cashToDelete);
    }
    setDeleteModalOpen(false);
    setCashToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setCashToDelete(null);
  };

  const deleteCash = (cash_id) => {
    toast.promise(
      api
      .delete(
        `/association/cash/settings/undo/${cash_id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: "Deleting Cash And Related Transactions...",
          success: (response) => {
              fetchWhyWeAreHere()
              associationFill(ao)
              handleDeleteCancel()
              return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
    )
  }


  const columns = [
    {
      field: "cid",
      headerName: "Id",
      flex: 100,
    },
    {
      field: "cdate",
      headerName: "Date(Cash deposits)",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{formatDateToYearMonthDay(new Date(params.row.cdate))}</b>
        </Typography>
      ),
    },
    {
      field: "cash_value",
      headerName: "Cash deposits",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{currencyFormat.format(params.row.cash_value)}</b>
        </Typography>
      ),
    },
    {
      field: "mdate",
      headerName: "Date(Momo deposits)",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{formatDateToYearMonthDay(new Date(params.row.mdate))}</b>
        </Typography>
      ),
    },
    {
      field: "momo_bal",
      headerName: "Momo deposits",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{currencyFormat.format(params.row.momo_bal)}</b>
        </Typography>
      ),
    },
    {
      field: "difference",
      headerName: "Difference",
      flex: 100,
      renderCell: (params) =>
        currencyFormat.format(params.row.momo_bal - params.row.cash_value),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 200,
      renderCell: (params) => {
        const one = params.row;
        return <Reconcile {...{ one, fetchWhyWeAreHere }} />;
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 100,
    },
    {
      field: "button",
      headerName: "Situation",
      flex: 100,
    },
    {
      field: "mid",
      headerName: "Id2",
      flex: 100,
    },
    {
      field: "taken",
      headerName: "Matched?",
      flex: 100,
    },
    {
      field: "rematched",
      headerName: "Rematched?",
      flex: 100,
    },
    {
      field: 'delete',
      headerName: "Delete",
      type: 'actions',
      renderCell: params => (
      <>
      {personaInfo?.role_name === 'Administrator' || 
       personaInfo?.role_name === 'Operations Manager' ||
       personaInfo?.role_name === 'Society Manager'
      ?(
        <Button
            size="small"
            color="error"
            variant="contained"
            sx={{
            borderRadius: 2,
            mr: 'auto',
            boxShadow:
                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
            "&:hover": {
                boxShadow:
                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                backgroundColor: "#14213d",
            },
            }}
            onClick={() => handleDeleteClick(params.row.cid)}
        >
            <DeleteRoundedIcon />
        </Button>)
        :null}
      </>
      )
  },
  ];

  const clus_columns = [
    {
      field: "id",
      headerName: "Id",
      flex: 10,
    },
    {
      field: "cluster",
      headerName: "Cluster",
      flex: 100,
      renderCell: (params) => (
        <Typography
          onClick={() => clusterFil(params.row)}
          sx={{ textDecoration: "underline", cursor: "pointer" }}
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>{params.row.cluster}</b>
        </Typography>
      ),
    },
    {
      field: "cluster_id",
      headerName: "Cluster_id",
      flex: 100,
    },
    {
      field: "cash",
      headerName: "Cash deposits",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{currencyFormat.format(params.row.cash)}</b>
        </Typography>
      ),
    },
    {
      field: "momo",
      headerName: "Momo deposits",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{currencyFormat.format(params.row.momo)}</b>
        </Typography>
      ),
    },
    {
      field: "difference",
      headerName: "Difference",
      flex: 100,
      renderCell: (params) =>
        currencyFormat.format(params.row.momo - params.row.cash),
    },
  ];

  const asso_init_columns = [
    {
      field: "id",
      headerName: "Id",
      flex: 10,
    },
    {
      field: "association_name",
      headerName: "Savings Group",
      flex: 100,
      renderCell: (params) => (
        <Typography
          onClick={() => associationFill(params.row)}
          sx={{ textDecoration: "underline", cursor: "pointer" }}
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>{params.row.association_name}</b>
        </Typography>
      ),
    },
    {
      field: "cash",
      headerName: "Cash deposits",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{currencyFormat.format(params.row.cash)}</b>
        </Typography>
      ),
    },
    {
      field: "momo",
      headerName: "Momo deposits",
      flex: 100,
      renderCell: (params) => (
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>{currencyFormat.format(params.row.momo)}</b>
        </Typography>
      ),
    },
    {
      field: "difference",
      headerName: "Difference",
      flex: 100,
      renderCell: (params) =>
        currencyFormat.format(params.row.momo - params.row.cash),
    },
  ];

  const associationFill = (asso) => {
    const data = new FormData();
    data.append("society_id", props.id);
    data.append("start_date", from);
    data.append("end_date", to);
    data.append("s_association_id", asso.id);
    setAo(asso)

    toast.promise(
      api.post("/association/cash/view/all/work", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (res) => {
          setData_sec(res.data?.Data);
          setAssociation_search_name(asso.association_name);
          setAssociation_search(asso.id);
          setDeep(true);
          setTable_cash(res.data?.cash_total);
          setTable_momo(res.data?.momo_total);
          return "Done";
        },
        error: (err) => {
          console.log(err);
          return "An error occurred";
        },
      }
    );
  };

  const clusterFil = (clus) => {
    const data = new FormData();
    data.append("society_id", props.id);
    data.append("start_date", from);
    data.append("end_date", to);
    data.append("s_association_id", 0);
    data.append("s_cluster_id", clus.id);

    toast.promise(
      api.post("/association/cash/view/all", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (res) => {
          setData(res.data?.Data);
          setClus_or_asso(false);
          setCluster_search_name(clus.cluster);
          setCluster_search(clus.id);
          setTable_cash(res.data?.cash_total);
          setTable_momo(res.data?.momo_total);
          return "Done";
        },
        error: (err) => {
          console.log(err);
          return "An error occurred";
        },
      }
    );
  };

  const handleCloseBackdrop = () => {
    setOpenn(false);
  };
  const handleOpenBackdrop = () => {
    setOpenn(true);
  };

  const formik = useFormik({
    initialValues: {
      transaction_id: null,
      bank_branch: "",
      momo_number: "",
      bank_name: "",
      date: dayjs(),
      amount_done: null,
      account_number: "",
      account_name: "",
      via: "",
      receiver_bank_name: "",
      receiver_momo_name: "",
      receiver_momo_number: "",
      receiver_bank_branch: "",
      receiver_account_number: "",
      receiver_account_name: "",
    },
    validationSchema: Yup.object({
      amount_done: Yup.number().required("Amount is required"),
      account_name: Yup.string().required("Name is Required"),
      date: Yup.string().required("date is required"),
    }),
    onSubmit: (values) => {
      handleOpenBackdrop();
      const data = new FormData();
      data.append("transaction_id", values.transaction_id);
      data.append("bank_branch", values.bank_branch);
      data.append("momo_number", values.momo_number);
      data.append("bank_name", values.bank_name);
      data.append("date", values.date);
      data.append("amount_done", values.amount_done);
      data.append("account_number", values.account_number);
      data.append("account_name", values.account_name);
      data.append("via", values.via);
      data.append("receiver_bank_name", values.receiver_bank_name);
      data.append("receiver_momo_name", values.receiver_momo_name);
      data.append("receiver_momo_number", values.receiver_momo_number);
      data.append("receiver_bank_branch", values.receiver_bank_branch);
      data.append("receiver_account_number", values.receiver_account_number);
      data.append("receiver_account_name", values.receiver_account_name);

      api
        .post(
          "/investors/transaction/investor/account/reconciliation/data/save",
          data,
          {
            headers: {
              Authorization: "Bearer " + fetchToken(),
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(function (response) {
          toast.success(response.data);
          closeInvestorModal();
          fetchAllAssos();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          handleCloseBackdrop();
        });
    },
  });

  const openInvestorModal = (view) => {
    formik.setFieldValue("transaction_id", view.id);
    formik.setFieldValue("bank_branch", view.bank_branch);
    formik.setFieldValue("momo_number", view.momo_number);
    formik.setFieldValue("bank_name", view.bank_name);
    formik.setFieldValue("amount_done", view.amount_done);
    formik.setFieldValue("account_number", view.account_number);
    formik.setFieldValue("account_name", view.account_name);
    formik.setFieldValue("via", view.via);
    formik.setFieldValue("receiver_bank_name", view.receiver_bank_name);
    formik.setFieldValue("receiver_momo_name", view.receiver_momo_name);
    formik.setFieldValue("receiver_momo_number", view.receiver_momo_number);
    formik.setFieldValue("receiver_bank_branch", view.receiver_bank_branch);
    formik.setFieldValue(
      "receiver_account_number",
      view.receiver_account_number
    );
    formik.setFieldValue("receiver_account_name", view.receiver_account_name);
    setHold_view(view);
    setInvestor_Modal(true);
  };

  const closeInvestorModal = () => {
    setHold_view([]);
    setInvestor_Modal(false);
    formik.handleReset();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  function formatDateToYearMonthDayTime(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${day}${suffix} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
  }

  const fetchAllAssos = () => {
    api
      .get(`/association/in/reconcile/${props.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAll_assos(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/association/in/reconcile/cluster/${props.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAll_cluss(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(
        `/investors/transaction/investor/account/reconciliation/data/${props.id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }
      )
      .then(function (response) {
        setInvestor_deposits(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchWhyWeAreHere = () => {
    const data = new FormData();
    data.append("society_id", props.id);
    data.append("start_date", "");
    data.append("end_date", "");
    data.append("s_association_id", 0);
    data.append("s_cluster_id", 0);
    api
      .post("/association/cash/view/all", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setData(response.data?.Data);
        setTable_cash(response.data?.cash_total);
        setTable_momo(response.data?.momo_total);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(
        `/association/get/association/cluster/reconciliations/working/${props.id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }
      )
      .then(function (response) {
        setClus_data(response.data?.all_data);
      })
      .catch(function (error) {
        console.log(error);
      });

      api
      .get("/users/su", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPersonaInfo(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleRematch = (
    cid,
    cdate,
    association_name,
    cash_value,
    momo_bal,
    mdate,
    reason_re,
    taken
  ) => {
    setSelected_cid(cid);
    setSelected_cdate(cdate);
    setSelected_association_name(association_name);
    setSelected_cash_value(cash_value);
    setSelected_momo_bal(momo_bal);
    setSelected_mdate(mdate);
    setRematch_reason(reason_re);
    setSelected_taken(taken);
    api
      .get(`/association/momo/rematch/details/${cid}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMomo_for_rematch(response.data?.data);
        setOpen_modal(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const filterHandleRematch = () => {
    const data = new FormData();
    data.append("cid", selected_cid);
    data.append("date", filter_datematch);
    api
      .post("/association/momo/rematch/details/filter", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMomo_for_rematch(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const noFil = () => {
    setFilter_datematch();
    api
      .get(`/association/momo/rematch/details/${selected_cid}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMomo_for_rematch(response.data?.data);
        setOpen_modal(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const rematchChosen = (m_id, re_date, re_bal) => {
    const data = new FormData();
    data.append("mid", m_id);
    data.append("cid", selected_cid);
    data.append("reason", rematch_reason);

    api
      .post("/association/momo/rematch/do", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response?.data);
        setRematched_date(re_date);
        setRematched_momo_bal(re_bal);
        fetchWhyWeAreHere();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 720,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleCancelRematch = () => {
    setSelected_cid();
    setSelected_cdate();
    setSelected_association_name();
    setSelected_cash_value();
    setSelected_momo_bal();
    setSelected_mdate();
    setMomo_for_rematch([]);
    setOpen_modal(false);
    setRematched_date();
    setRematched_momo_bal(null);
    fetchWhyWeAreHere();
    setRematch_reason("");
    setSelected_taken();
  };

  useEffect(() => {
    fetchWhyWeAreHere();
    fetchAllAssos();
  }, []);

  const handleDateNo = () => {
    setFrom("");
    setTo("");
    setAssociation_search(0);
    setAssociation_search_name("");
    setCluster_search(0);
    setCluster_search_name("");
    setMatched(null);
    setFil_status(null);
    fetchWhyWeAreHere();
  };

  const deepHandleDateNo = () => {
    setFrom("");
    setTo("");
    setDeep(false);
    setClus_or_asso(false);
    setAssociation_search(0);
    setAssociation_search_name("");
    setCluster_search(0);
    setCluster_search_name("");
    setMatched(null);
    setFil_status(null);
    fetchWhyWeAreHere();
  };

  const switcher = () => {
    fetchWhyWeAreHere();
    setClus_or_asso((prev) => !prev);
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const isToday = (someDate) => {
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };

  const renderTitle = (date) => {
    const formattedDate = formatDateToYearMonthDay(date);
    return (
      <Typography
        variant="h5"
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>{formattedDate}</b>
        {isToday(date) && (
          <Chip
            variant="outlined"
            size="small"
            sx={{ m: 1 }}
            color="success"
            label="today"
          />
        )}
      </Typography>
    );
  };
  // new Date(item.date) >= new Date(from)
  const handleDate = () => {
    if (clus_or_asso) {
      const data_post = new FormData();
      data_post.append("society_id", props.id);
      data_post.append("start_date", from);
      data_post.append("end_date", to);
      data_post.append("s_cluster_id", cluster_search ? cluster_search : 0);

      toast.promise(
        api.post(
          "/association/get/association/cluster/reconciliations/filtering",
          data_post,
          {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }
        ),
        {
          loading: "Filtering...",
          success: (res) => {
            setClus_data(res.data?.data);
            setTable_cash(res.data?.cash_total);
            setTable_momo(res.data?.momo_total);
            return "Filtered!";
          },
          error: (err) => {
            console.log(err);
            return "An error occurred";
          },
        }
      );
    } else {
      if (deep) {
        const data = new FormData();
        data.append("society_id", props.id);
        data.append("start_date", from);
        data.append("end_date", to);
        data.append("s_association_id", association_search);
        data.append("matched", matched === null ? 0 : matched);
        data.append("status", fil_status === null ? 0 : fil_status);

        toast.promise(
          api.post("/association/cash/view/all/work", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }),
          {
            loading: "Loading...",
            success: (res) => {
              setData_sec(res.data?.Data);
              setTable_cash(res.data?.cash_total);
              setTable_momo(res.data?.momo_total);
              return "Done";
            },
            error: (err) => {
              console.log(err);
              return "An error occurred";
            },
          }
        );
      } else {
        const data_post = new FormData();
        data_post.append("society_id", props.id);
        data_post.append("start_date", from);
        data_post.append("end_date", to);
        data_post.append(
          "s_association_id",
          association_search ? association_search : 0
        );
        data_post.append("s_cluster_id", 0);

        toast.promise(
          api.post("/association/cash/view/all", data_post, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }),
          {
            loading: "Filtering...",
            success: (res) => {
              setData(res.data?.Data);
              setTable_cash(res.data?.cash_total);
              setTable_momo(res.data?.momo_total);
              return "Filtered!";
            },
            error: (err) => {
              console.log(err);
              return "An error occurred";
            },
          }
        );
      }
    }
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* Delete Confirmation Modal */}
        <Dialog
                open={deleteModalOpen}
                onClose={handleDeleteCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete this cash record? This action cannot be undone and will permanently delete all cash data including transactions done on specified savings group an on the specified date.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleDeleteCancel} color="primary">
                    Cancel
                  </Button>
                  <Button 
                    onClick={handleDeleteConfirm} 
                    color="error"
                    autoFocus
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
        {props.dash ? (
          <>
            <Grid item xs={12} md={12}>
              <Accordion sx={{ borderRadius: 2, marginBottom: 3 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    subtitle="h5"
                    sx={{ color: "black" }}
                  >
                    <b>Filters</b>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <TextField
                      type="date"
                      required
                      helperText="From"
                      size="small"
                      value={from}
                      onChange={(e) => setFrom(e.target.value)}
                      sx={{ marginRight: 4 }}
                    />
                    <TextField
                      type="date"
                      required
                      helperText="To"
                      value={to}
                      onChange={(e) => setTo(e.target.value)}
                      size="small"
                      sx={{ marginRight: 2 }}
                    />
                    {clus_or_asso ? (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={all_cluss}
                        sx={{ width: 250 }}
                        getOptionLabel={(option) => option.cluster_name}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        onChange={(event, value) => {
                          setCluster_search(value.cluster_id);
                          setCluster_search_name(value.cluster_name);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            helperText="Filter Cluster"
                          />
                        )}
                      />
                    ) : (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={all_assos}
                        sx={{ width: 250 }}
                        getOptionLabel={(option) => option.association_name}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        onChange={(event, value) => {
                          setAssociation_search(value.association_id);
                          setAssociation_search_name(value.association_name);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            helperText="Filter savings group"
                          />
                        )}
                      />
                    )}

                    {clus_or_asso ? null : (
                      <>
                        {deep ? (
                          <>
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={[
                                { id: 1, status: "Rematched" },
                                { id: 2, status: "Unmatched" },
                              ]}
                              sx={{ width: 220, marginLeft: "7px" }}
                              getOptionLabel={(option) => option.status}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, value) => setMatched(value.id)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  size="small"
                                  helperText="Filter Rematched"
                                />
                              )}
                            />

                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={[
                                { id: 1, status: "Not Reconciled" },
                                { id: 2, status: "Conflict" },
                                { id: 2, status: "Balanced" },
                              ]}
                              sx={{ width: 220, marginLeft: "7px" }}
                              getOptionLabel={(option) => option.status}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, value) =>
                                setFil_status(value.id)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  size="small"
                                  helperText="Filter Status"
                                />
                              )}
                            />
                          </>
                        ) : null}
                      </>
                    )}

                    <IconButton onClick={handleDate}>
                      <FilterAltOutlinedIcon />
                    </IconButton>
                    <IconButton onClick={handleDateNo}>
                      <CancelIcon />
                    </IconButton>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Chip
                  size="medium"
                  label={
                    clus_or_asso ? (
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Switch to Saving Groups</b>
                      </Typography>
                    ) : (
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Switch to Clusters</b>
                      </Typography>
                    )
                  }
                  onClick={switcher}
                  sx={{
                    borderRadius: 2,
                    m: 3,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#2b2d42",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                    },
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Period</b>
                  </Typography>
                  <Typography
                    variant="h5"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      {from
                        ? formatDateToYearMonthDay(new Date(from))
                        : "Not filtered"}
                      {" - "}
                      {to
                        ? formatDateToYearMonthDay(new Date(to))
                        : "Not filtered"}
                    </b>
                  </Typography>
                </div>

                <Divider
                  sx={{ mx: 3 }}
                  orientation="vertical"
                  variant="middle"
                  flexItem
                />

                {!clus_or_asso ? (
                  <>
                    {cluster_search_name ? (
                      <>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Cluster</b>
                          </Typography>
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {cluster_search_name
                                ? cluster_search_name
                                : "Not filtered"}
                            </b>
                          </Typography>
                        </div>
                        <Divider
                          sx={{ mx: 3 }}
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                      </>
                    ) : null}

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Savings Group</b>
                      </Typography>
                      <Typography
                        variant="h5"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>
                          {association_search_name
                            ? association_search_name
                            : "Not filtered"}
                        </b>
                      </Typography>
                    </div>
                  </>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Cluster</b>
                    </Typography>
                    <Typography
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>
                        {cluster_search_name
                          ? cluster_search_name
                          : "Not filtered"}
                      </b>
                    </Typography>
                  </div>
                )}

                <Divider
                  sx={{ mx: 3 }}
                  orientation="vertical"
                  variant="middle"
                  flexItem
                />

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Current table totals</b>
                    </Typography>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Cash deposits total</b>
                      </Typography>
                      <Typography
                        variant="h5"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{currencyFormat.format(table_cash)}</b>
                      </Typography>
                    </div>

                    <Divider
                      sx={{ mx: 2 }}
                      orientation="vertical"
                      variant="middle"
                      flexItem
                    />

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 2, sans-serif"
                      >
                        <b>Momo deposits total</b>
                      </Typography>
                      <Typography
                        variant="h5"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{currencyFormat.format(table_momo)}</b>
                      </Typography>
                    </div>

                    <Divider
                      sx={{ mx: 2 }}
                      orientation="vertical"
                      variant="middle"
                      flexItem
                    />

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Difference total</b>
                      </Typography>
                      <Typography
                        variant="h5"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{currencyFormat.format(table_momo - table_cash)}</b>
                      </Typography>
                    </div>
                  </div>
                </div>

                <Divider
                  sx={{ mx: 2 }}
                  orientation="vertical"
                  variant="middle"
                  flexItem
                />

                <div style={{ m: "auto" }} onClick={deepHandleDateNo}>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Refresh Table</b>
                    <IconButton sx={{ ml: 1 }}>
                      <CachedRoundedIcon sx={{ color: "black" }} />
                    </IconButton>
                  </Typography>
                </div>
              </div>
              <div>
                {clus_or_asso ? (
                  <DataGrid
                    rows={clus_data}
                    columns={clus_columns}
                    autoHeight
                    checkboxSelection
                    getRowId={(row) => row.id}
                    slots={{ toolbar: GridToolbar }}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          id: false,
                          status: false,
                          cluster_id: false,
                          note: false,
                        },
                      },
                    }}
                  />
                ) : null}

                {!clus_or_asso ? (
                  <>
                    {deep ? (
                      <DataGrid
                        rows={filteredData}
                        columns={columns}
                        autoHeight
                        checkboxSelection
                        getRowId={(row) => row.cid}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                          columns: {
                            columnVisibilityModel: {
                              cid: false,
                              status: false,
                              button: false,
                              mid: false,
                              taken: false,
                              rematched: false,
                              actions: props.dash ? false : true,
                            },
                          },
                        }}
                      />
                    ) : null}
                    {!deep ? (
                      <DataGrid
                        rows={data}
                        columns={asso_init_columns}
                        autoHeight
                        checkboxSelection
                        getRowId={(row) => row.id}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                          columns: {
                            columnVisibilityModel: {
                              id: false,
                            },
                          },
                        }}
                      />
                    ) : null}
                  </>
                ) : null}
              </div>
            </Grid>
            
          </>
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Tabs
                  variant="fullWidth"
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label={
                      <b
                        style={{
                          color: "Blue",
                          fontFamily:
                            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                        }}
                      >
                        Savings Groups Deposits
                      </b>
                    }
                    {...a11yProps(0)}
                  />
                  <Tab
                    label={
                      <b
                        style={{
                          color: "brown",
                          fontFamily:
                            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                        }}
                      >
                        Investors Deposits
                      </b>
                    }
                    {...a11yProps(1)}
                  />
                  <Tab
                    label={
                      <b
                        style={{
                          color: "green",
                          fontFamily:
                            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                        }}
                      >
                        Bank Reconciliations
                      </b>
                    }
                    {...a11yProps(2)}
                  />
                  <Tab
                    label={
                      <b
                        style={{
                          color: "green",
                          fontFamily:
                            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                        }}
                      >
                        Daily Cash Reconciliations
                      </b>
                    }
                    {...a11yProps(3)}
                  />
                </Tabs>
              </Grid>
              <Grid item xs={12} md={12}>
                <CustomTabPanel value={value} index={0}>
                  <Typography
                    variant="h3"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    sx={{ textAlign: "center", marginBottom: 5 }}
                  >
                    <b>Reconciliations</b>
                  </Typography>
                  {permissions &&
                  permissions.view_society_reconciliatio_form === true ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Tabs
                          value={value2}
                          onChange={handleChange2}
                          aria-label="basic tabs example"
                        >
                          <Tab
                            label={
                              <b
                                style={{
                                  fontFamily:
                                    "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                                }}
                              >
                                Table
                              </b>
                            }
                            {...a11yProps(0)}
                          />
                          <Tooltip lable="Filter down for cards">
                            <Tab
                              label={
                                <b
                                  style={{
                                    fontFamily:
                                      "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                                  }}
                                >
                                  Cards
                                </b>
                              }
                              {...a11yProps(1)}
                              disabled={!deep}
                            />
                          </Tooltip>
                        </Tabs>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Accordion sx={{ borderRadius: 2, marginBottom: 3 }}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              subtitle="h5"
                              sx={{ color: "black" }}
                            >
                              <b>Filters</b>
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                              <TextField
                                type="date"
                                required
                                helperText="From"
                                size="small"
                                value={from}
                                onChange={(e) => setFrom(e.target.value)}
                                sx={{ marginRight: 4 }}
                              />
                              <TextField
                                type="date"
                                required
                                helperText="To"
                                value={to}
                                onChange={(e) => setTo(e.target.value)}
                                size="small"
                                sx={{ marginRight: 2 }}
                              />
                              {clus_or_asso ? (
                                <Autocomplete
                                  disablePortal
                                  id="combo-box-demo"
                                  options={all_cluss}
                                  sx={{ width: 250 }}
                                  getOptionLabel={(option) =>
                                    option.cluster_name
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  onChange={(event, value) => {
                                    setCluster_search(value.cluster_id);
                                    setCluster_search_name(value.cluster_name);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      size="small"
                                      helperText="Filter Cluster"
                                    />
                                  )}
                                />
                              ) : (
                                <Autocomplete
                                  disablePortal
                                  id="combo-box-demo"
                                  options={all_assos}
                                  sx={{ width: 250 }}
                                  getOptionLabel={(option) =>
                                    option.association_name
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  onChange={(event, value) => {
                                    setAssociation_search(value.association_id);
                                    setAssociation_search_name(
                                      value.association_name
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      size="small"
                                      helperText="Filter savings group"
                                    />
                                  )}
                                />
                              )}

                              {clus_or_asso ? null : (
                                <>
                                  {deep ? (
                                    <>
                                      <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={[
                                          { id: 1, status: "Rematched" },
                                          { id: 2, status: "Unmatched" },
                                        ]}
                                        sx={{ width: 220, marginLeft: "7px" }}
                                        getOptionLabel={(option) =>
                                          option.status
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.id === value.id
                                        }
                                        onChange={(event, value) =>
                                          setMatched(value.id)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            helperText="Filter Rematched"
                                          />
                                        )}
                                      />

                                      <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={[
                                          { id: 1, status: "Not Reconciled" },
                                          { id: 2, status: "Conflict" },
                                          { id: 2, status: "Balanced" },
                                        ]}
                                        sx={{ width: 220, marginLeft: "7px" }}
                                        getOptionLabel={(option) =>
                                          option.status
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.id === value.id
                                        }
                                        onChange={(event, value) =>
                                          setFil_status(value.id)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            helperText="Filter Status"
                                          />
                                        )}
                                      />
                                    </>
                                  ) : null}
                                </>
                              )}

                              <IconButton onClick={handleDate}>
                                <FilterAltOutlinedIcon />
                              </IconButton>
                              <IconButton onClick={handleDateNo}>
                                <CancelIcon />
                              </IconButton>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <CustomTabPanel value={value2} index={0}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Chip
                              size="medium"
                              label={
                                clus_or_asso ? (
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Switch to Saving Groups</b>
                                  </Typography>
                                ) : (
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Switch to Clusters</b>
                                  </Typography>
                                )
                              }
                              onClick={switcher}
                              sx={{
                                borderRadius: 2,
                                m: 3,
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "#2b2d42",
                                color: "#fff",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                },
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                sx={{ textAlign: "center" }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Period</b>
                              </Typography>
                              <Typography
                                variant="h5"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>
                                  {from
                                    ? formatDateToYearMonthDay(new Date(from))
                                    : "Not filtered"}
                                  {" - "}
                                  {to
                                    ? formatDateToYearMonthDay(new Date(to))
                                    : "Not filtered"}
                                </b>
                              </Typography>
                            </div>

                            <Divider
                              sx={{ mx: 3 }}
                              orientation="vertical"
                              variant="middle"
                              flexItem
                            />

                            {!clus_or_asso ? (
                              <>
                                {cluster_search_name ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Typography
                                        sx={{ textAlign: "center" }}
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Cluster</b>
                                      </Typography>
                                      <Typography
                                        variant="h5"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>
                                          {cluster_search_name
                                            ? cluster_search_name
                                            : "Not filtered"}
                                        </b>
                                      </Typography>
                                    </div>
                                    <Divider
                                      sx={{ mx: 3 }}
                                      orientation="vertical"
                                      variant="middle"
                                      flexItem
                                    />
                                  </>
                                ) : null}

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{ textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Savings Group</b>
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>
                                      {association_search_name
                                        ? association_search_name
                                        : "Not filtered"}
                                    </b>
                                  </Typography>
                                </div>
                              </>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography
                                  sx={{ textAlign: "center" }}
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Cluster</b>
                                </Typography>
                                <Typography
                                  variant="h5"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>
                                    {cluster_search_name
                                      ? cluster_search_name
                                      : "Not filtered"}
                                  </b>
                                </Typography>
                              </div>
                            )}

                            <Divider
                              sx={{ mx: 3 }}
                              orientation="vertical"
                              variant="middle"
                              flexItem
                            />

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div>
                                <Typography
                                  sx={{ textAlign: "center" }}
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Current table totals</b>
                                </Typography>
                              </div>
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{ textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Cash deposits total</b>
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>{currencyFormat.format(table_cash)}</b>
                                  </Typography>
                                </div>

                                <Divider
                                  sx={{ mx: 2 }}
                                  orientation="vertical"
                                  variant="middle"
                                  flexItem
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{ textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 2, sans-serif"
                                  >
                                    <b>Momo deposits total</b>
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>{currencyFormat.format(table_momo)}</b>
                                  </Typography>
                                </div>

                                <Divider
                                  sx={{ mx: 2 }}
                                  orientation="vertical"
                                  variant="middle"
                                  flexItem
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{ textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Difference total</b>
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>
                                      {currencyFormat.format(
                                        table_momo - table_cash
                                      )}
                                    </b>
                                  </Typography>
                                </div>
                              </div>
                            </div>

                            <Divider
                              sx={{ mx: 2 }}
                              orientation="vertical"
                              variant="middle"
                              flexItem
                            />

                            <div
                              style={{ m: "auto" }}
                              onClick={deepHandleDateNo}
                            >
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Refresh Table</b>
                                <IconButton sx={{ ml: 1 }}>
                                  <CachedRoundedIcon sx={{ color: "black" }} />
                                </IconButton>
                              </Typography>
                            </div>
                          </div>
                          <div>
                            {clus_or_asso ? (
                              <DataGrid
                                rows={clus_data}
                                columns={clus_columns}
                                autoHeight
                                checkboxSelection
                                getRowId={(row) => row.id}
                                slots={{ toolbar: GridToolbar }}
                                initialState={{
                                  columns: {
                                    columnVisibilityModel: {
                                      id: false,
                                      status: false,
                                      cluster_id: false,
                                      note: false,
                                    },
                                  },
                                }}
                              />
                            ) : null}

                            {!clus_or_asso ? (
                              <>
                                {deep ? (
                                  <DataGrid
                                    rows={filteredData}
                                    columns={columns}
                                    autoHeight
                                    checkboxSelection
                                    getRowId={(row) => row.cid}
                                    slots={{ toolbar: GridToolbar }}
                                    initialState={{
                                      columns: {
                                        columnVisibilityModel: {
                                          cid: false,
                                          status: false,
                                          button: false,
                                          mid: false,
                                          taken: false,
                                          rematched: false,
                                        },
                                      },
                                    }}
                                  />
                                ) : null}
                                {!deep ? (
                                  <DataGrid
                                    rows={data}
                                    columns={asso_init_columns}
                                    autoHeight
                                    checkboxSelection
                                    getRowId={(row) => row.id}
                                    slots={{ toolbar: GridToolbar }}
                                    initialState={{
                                      columns: {
                                        columnVisibilityModel: {
                                          id: false,
                                        },
                                      },
                                    }}
                                  />
                                ) : null}
                              </>
                            ) : null}
                          </div>
                        </CustomTabPanel>
                        <CustomTabPanel value={value2} index={1}>
                          <Box
                            sx={{
                              display: "flex",
                              marginBottom: 20,
                              flexWrap: "wrap",
                              maxHeight: 740,
                              overflow: "auto",
                              "&::-webkit-scrollbar": {
                                width: "7px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography
                                  sx={{ textAlign: "center" }}
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Period</b>
                                </Typography>
                                <Typography
                                  variant="h5"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>
                                    {from
                                      ? formatDateToYearMonthDay(new Date(from))
                                      : "Not filtered"}
                                    {" - "}
                                    {to
                                      ? formatDateToYearMonthDay(new Date(to))
                                      : "Not filtered"}
                                  </b>
                                </Typography>
                              </div>

                              <Divider
                                sx={{ mx: 3 }}
                                orientation="vertical"
                                variant="middle"
                                flexItem
                              />

                              {!clus_or_asso ? (
                                <>
                                  {cluster_search_name ? (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <Typography
                                          sx={{ textAlign: "center" }}
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Cluster</b>
                                        </Typography>
                                        <Typography
                                          variant="h5"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>
                                            {cluster_search_name
                                              ? cluster_search_name
                                              : "Not filtered"}
                                          </b>
                                        </Typography>
                                      </div>
                                      <Divider
                                        sx={{ mx: 3 }}
                                        orientation="vertical"
                                        variant="middle"
                                        flexItem
                                      />
                                    </>
                                  ) : null}

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                      sx={{ textAlign: "center" }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Savings Group</b>
                                    </Typography>
                                    <Typography
                                      variant="h5"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>
                                        {association_search_name
                                          ? association_search_name
                                          : "Not filtered"}
                                      </b>
                                    </Typography>
                                  </div>
                                </>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    sx={{ textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Cluster</b>
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>
                                      {cluster_search_name
                                        ? cluster_search_name
                                        : "Not filtered"}
                                    </b>
                                  </Typography>
                                </div>
                              )}

                              <Divider
                                sx={{ mx: 3 }}
                                orientation="vertical"
                                variant="middle"
                                flexItem
                              />

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div>
                                  <Typography
                                    sx={{ textAlign: "center" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Current table totals</b>
                                  </Typography>
                                </div>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                      sx={{ textAlign: "center" }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Cash deposits total</b>
                                    </Typography>
                                    <Typography
                                      variant="h5"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>{currencyFormat.format(table_cash)}</b>
                                    </Typography>
                                  </div>

                                  <Divider
                                    sx={{ mx: 2 }}
                                    orientation="vertical"
                                    variant="middle"
                                    flexItem
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                      sx={{ textAlign: "center" }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 2, sans-serif"
                                    >
                                      <b>Momo deposits total</b>
                                    </Typography>
                                    <Typography
                                      variant="h5"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>{currencyFormat.format(table_momo)}</b>
                                    </Typography>
                                  </div>

                                  <Divider
                                    sx={{ mx: 2 }}
                                    orientation="vertical"
                                    variant="middle"
                                    flexItem
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                      sx={{ textAlign: "center" }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Difference total</b>
                                    </Typography>
                                    <Typography
                                      variant="h5"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>
                                        {currencyFormat.format(
                                          table_momo - table_cash
                                        )}
                                      </b>
                                    </Typography>
                                  </div>
                                </div>
                              </div>

                              <Divider
                                sx={{ mx: 2 }}
                                orientation="vertical"
                                variant="middle"
                                flexItem
                              />

                              <div
                                style={{ m: "auto" }}
                                onClick={deepHandleDateNo}
                              >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Refresh Table</b>
                                  <IconButton sx={{ ml: 1 }}>
                                    <CachedRoundedIcon
                                      sx={{ color: "black" }}
                                    />
                                  </IconButton>
                                </Typography>
                              </div>
                            </div>
                            {data_sec &&
                              filteredData.map((one) => (
                                <Card
                                  sx={{
                                    m: 1,
                                    m: 1,
                                    borderRadius: 7,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                    borderStyle: "groove",
                                    borderColor:
                                      one.status === "Not Reconciled"
                                        ? "red"
                                        : "white",
                                  }}
                                >
                                  <CardHeader
                                    title={
                                      <Typography
                                        variant="h5"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>
                                          {renderTitle(new Date(one.cdate))}
                                        </b>
                                      </Typography>
                                    }
                                    subheader={
                                      <Typography
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        variant="subtitle"
                                      >
                                        <b>{one.association_name}</b>
                                      </Typography>
                                    }
                                  />
                                  <CardContent>
                                    <Box
                                      sx={{
                                        display: "block",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          Cash Deposits:{" "}
                                          <span>
                                            {currencyFormat.format(
                                              one.cash_value
                                            )}
                                          </span>
                                        </b>
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          Momo Deposits:{" "}
                                          {one.mdate === "N/A" &&
                                          one.taken === true
                                            ? "N/A"
                                            : currencyFormat.format(
                                                one.momo_bal
                                              )}
                                        </b>
                                      </Typography>
                                      <Typography
                                        sx={{ color: "#540b0e" }}
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>
                                          Difference:{" "}
                                          {one.mdate === "N/A" ||
                                          one.taken === true
                                            ? currencyFormat.format(
                                                one.cash_value
                                              )
                                            : currencyFormat.format(
                                                one.cash_value - one.momo_bal
                                              )}
                                        </b>
                                      </Typography>
                                    </Box>
                                    <Box sx={{ m: "5px" }}>
                                      {one.mdate === "N/A" &&
                                      one.taken === true ? (
                                        <Typography
                                          sx={{ display: "inline-flex" }}
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>
                                            Momo deposits used for another date
                                            (rematch to reconcile)
                                          </b>
                                        </Typography>
                                      ) : (
                                        <Reconcile
                                          {...{ one, fetchWhyWeAreHere }}
                                        />
                                      )}
                                    </Box>
                                    <Box
                                      sx={{
                                        mt: 2,
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Typography
                                        sx={{ display: "inline-flex" }}
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <CheckCircleIcon
                                          color={
                                            one.rematched || one.taken
                                              ? "success"
                                              : "primary"
                                          }
                                          fontSize="medium"
                                          sx={{ marginRight: 1 }}
                                        />
                                        <Chip
                                          sx={{
                                            boxShadow:
                                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                            minWidth: 0,
                                            "&:hover": {
                                              boxShadow:
                                                "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            },
                                          }}
                                          size="small"
                                          onClick={() =>
                                            handleRematch(
                                              one.cid,
                                              one.cdate,
                                              one.association_name,
                                              one.cash_value,
                                              one.momo_bal,
                                              one.mdate,
                                              one.reason,
                                              one.taken
                                            )
                                          }
                                          variant="contained"
                                          label={
                                            <b style={{ color: "darkblue" }}>
                                              Rematch
                                            </b>
                                          }
                                        />
                                      </Typography>
                                      <div style={{ marginLeft: "auto" }}>
                                        {one.status === "Not Reconciled" ? (
                                          <Chip
                                            color="success"
                                            variant="outlined"
                                            label={one.status}
                                            deleteIcon={<CancelIcon />}
                                            sx={{
                                              boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                              minWidth: 0,
                                            }}
                                            size="small"
                                          />
                                        ) : one.status === "Conflict" ? (
                                          <Chip
                                            color="warning"
                                            label={one.status}
                                            deleteIcon={<DoneIcon />}
                                            sx={{
                                              boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                              minWidth: 0,
                                            }}
                                            size="small"
                                          />
                                        ) : one.status === "Balanced" ? (
                                          <Chip
                                            color="success"
                                            label={one.status}
                                            deleteIcon={<DoneAllIcon />}
                                            sx={{
                                              boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                              minWidth: 0,
                                            }}
                                            size="small"
                                          />
                                        ) : null}
                                      </div>
                                    </Box>
                                  </CardContent>
                                </Card>
                              ))}
                          </Box>
                        </CustomTabPanel>
                      </Grid>
                    </Grid>
                  ) : null}
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography
                        variant="h3"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        sx={{ textAlign: "center", marginBottom: 5 }}
                      >
                        <b>Reconciliations</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Box
                        sx={{
                          display: "flex",
                          marginBottom: 20,
                          flexWrap: "wrap",
                          maxHeight: 740,
                          overflow: "auto",
                          "&::-webkit-scrollbar": {
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        {investor_deposits.map((view) => (
                          <Card
                            onClick={() => openInvestorModal(view)}
                            sx={{
                              m: 1,
                              borderRadius: 7,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                              "&:hover": {
                                borderStyle: "groove",
                                borderW: "15px",
                                borderColor: "brown",
                              },
                            }}
                          >
                            <CardHeader
                              title={
                                <Typography
                                  variant="h5"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>
                                    {formatDateToYearMonthDayTime(
                                      new Date(view.transaction_date)
                                    )}
                                  </b>
                                </Typography>
                              }
                              subheader={
                                <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  variant="subtitle"
                                >
                                  <b>{view.investor_name}</b>
                                </Typography>
                              }
                            />
                            <CardContent>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  Amount: {currencyFormat.format(view.amount)}
                                </b>
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Narration: {view.narration}</b>
                              </Typography>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Prepared By: {view.username}</b>
                              </Typography>
                              <Divider variant="middle" sx={{ m: 1 }} />
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  Payment Method:{" "}
                                  {view.via ? view.via : "Not Set"}
                                </b>
                              </Typography>
                              {view.via === "Bank" ? (
                                <>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Bank Name: {view.bank_name}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Bank Branch: {view.bank_branch}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Account Number: {view.account_number}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Account Name: {view.account_name}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Amount:{" "}
                                      {currencyFormat.format(view.amount_done)}
                                    </b>
                                  </Typography>
                                  <Divider variant="middle" sx={{ m: 1 }} />
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Receiver Bank Name:{" "}
                                      {view.receiver_bank_name}
                                    </b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Receiver Bank Branch:{" "}
                                      {view.receiver_bank_branch}
                                    </b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Receiver Account Number:{" "}
                                      {view.receiver_account_number}
                                    </b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Receiver Account Name:{" "}
                                      {view.receiver_account_name}
                                    </b>
                                  </Typography>
                                </>
                              ) : view.via === "Momo" ? (
                                <>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Momo number: {view.momo_number}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Account Name: {view.account_name}</b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Amount:{" "}
                                      {currencyFormat.format(view.amount_done)}
                                    </b>
                                  </Typography>
                                  <Divider variant="middle" sx={{ m: 1 }} />
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Receiver Momo number:{" "}
                                      {view.receiver_momo_number}
                                    </b>
                                  </Typography>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Receiver Account Name:{" "}
                                      {view.receiver_momo_name}
                                    </b>
                                  </Typography>
                                </>
                              ) : (
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>No data recorder</b>
                                </Typography>
                              )}
                            </CardContent>
                            <CardActions>
                              <Chip
                                size="medium"
                                variant="outlined"
                                label={
                                  <Typography
                                    variant="subtitle"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>
                                      {view.reconciled === true
                                        ? "Reconciled"
                                        : "Not Reconciled"}
                                    </b>
                                  </Typography>
                                }
                                sx={{
                                  borderRadius: 2,
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    view.reconciled === true ? "green" : "red",
                                  color: "#000",
                                }}
                              />
                              <Chip
                                size="medium"
                                variant="outlined"
                                label={
                                  <Typography
                                    variant="subtitle"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>
                                      {view.status === true
                                        ? "Matched"
                                        : "Conflict"}
                                    </b>
                                  </Typography>
                                }
                                sx={{
                                  borderRadius: 2,
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    view.status === true ? "green" : "red",
                                  color: "#000",
                                }}
                              />
                            </CardActions>
                          </Card>
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2}>
                  <BankRecon society_id={props.id} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <DailyBankRecon society_id={props.id} />
                </CustomTabPanel>
              </Grid>
            </Grid>
          </>
        )}

        {/* investor modal */}
        <Modal
          open={investor_modal}
          onClose={closeInvestorModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Tabs
                  variant="fullWidth"
                  value={value1}
                  onChange={handleChange1}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label={
                      <b
                        style={{
                          color: "Blue",
                          fontFamily:
                            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                        }}
                      >
                        Bank Deposit
                      </b>
                    }
                    {...a11yProps(0)}
                  />
                  <Tab
                    label={
                      <b
                        style={{
                          color: "brown",
                          fontFamily:
                            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                        }}
                      >
                        Momo Deposit
                      </b>
                    }
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Grid>
              <Grid item xs={12} md={12}>
                <CustomTabPanel value={value1} index={0}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        sx={{ textAlign: "center", m: 2 }}
                        variant="h4"
                      >
                        <b>Bank Deposit</b>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <DateTimePicker
                        name="date"
                        value={formik.values.date}
                        onChange={(date) => formik.setFieldValue("date", date)}
                        // orientation="landscape"
                        slotProps={{
                          textField: {
                            helperText: (
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>DateTime Of Transaction</b>
                              </Typography>
                            ),
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Amount</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="amount_done"
                        value={formik.values.amount_done}
                        onChange={formik.handleChange}
                        type="number"
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.amount_done &&
                          Boolean(formik.errors.amount_done)
                        }
                        inputProps={{ step: "any" }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Bank Name</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="bank_name"
                        value={formik.values.bank_name}
                        onChange={formik.handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Bank Branch</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="bank_branch"
                        value={formik.values.bank_branch}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Account Number</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="account_number"
                        value={formik.values.account_number}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Account Name</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="account_name"
                        value={formik.values.account_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.account_name &&
                          Boolean(formik.errors.account_name)
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Divider variant="middle" sx={{ m: 3 }} />
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Receiver Bank Name</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="receiver_bank_name"
                        value={formik.values.receiver_bank_name}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Receiver Bank Branch</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="receiver_bank_branch"
                        value={formik.values.receiver_bank_branch}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Receiver Account Number</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="receiver_account_number"
                        value={formik.values.receiver_account_number}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Receiver Account Name</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="receiver_account_name"
                        value={formik.values.receiver_account_name}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ display: "flex", flexDirection: "row" }}
                    >
                      <Chip
                        size="medium"
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Cancel</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "red",
                          color: "#000",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#fff",
                          },
                        }}
                        onClick={closeInvestorModal}
                      />
                      <Chip
                        size="medium"
                        disabled={formik.isSubmitting}
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Reconcile</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "green",
                          color: "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#fff",
                          },
                        }}
                        onClick={() => {
                          formik.setFieldValue("via", "Bank"),
                            formik.handleSubmit();
                        }}
                      />
                    </Grid>
                  </Grid>
                </CustomTabPanel>
                <CustomTabPanel value={value1} index={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        sx={{ textAlign: "center", m: 2 }}
                        variant="h4"
                      >
                        <b>Momo Deposit</b>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <DateTimePicker
                        name="date"
                        value={formik.values.date}
                        onChange={(date) => formik.setFieldValue("date", date)}
                        // orientation="landscape"
                        slotProps={{
                          textField: {
                            helperText: (
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>DateTime Of Transaction</b>
                              </Typography>
                            ),
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Amount</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="amount_done"
                        value={formik.values.amount_done}
                        onChange={formik.handleChange}
                        type="number"
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.amount_done &&
                          Boolean(formik.errors.amount_done)
                        }
                        inputProps={{ step: "any" }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Momo Number</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="momo_number"
                        value={formik.values.momo_number}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Account Name</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="account_name"
                        value={formik.values.account_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.account_name &&
                          Boolean(formik.errors.account_name)
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Divider variant="middle" sx={{ m: 3 }} />
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Receiver Momo Number</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="receiver_momo_number"
                        value={formik.values.receiver_momo_number}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Receiver Account Name</b>
                          </Typography>
                        }
                        size="small"
                        fullWidth
                        name="receiver_momo_name"
                        value={formik.values.receiver_momo_name}
                        onChange={formik.handleChange}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{ display: "flex", flexDirection: "row" }}
                    >
                      <Chip
                        size="medium"
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Cancel</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "red",
                          color: "#000",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#fff",
                          },
                        }}
                        onClick={closeInvestorModal}
                      />
                      <Chip
                        size="medium"
                        disabled={formik.isSubmitting}
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Reconcile</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "green",
                          color: "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#fff",
                          },
                        }}
                        onClick={() => {
                          formik.setFieldValue("via", "Momo"),
                            formik.handleSubmit();
                        }}
                      />
                    </Grid>
                  </Grid>
                </CustomTabPanel>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={open_modal}
          onClose={handleCancelRematch}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} sx={{ mb: 2 }}>
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center" }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{selected_association_name}</b>
                </Typography>
              </Grid>

              <Grid item xs={6} md={6}>
                <Typography
                  sx={{ textAlign: "center" }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{formatDateToYearMonthDay(new Date(selected_cdate))}</b>
                </Typography>
                <Typography
                  sx={{ textAlign: "center" }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>
                    Cash Deposits: {currencyFormat.format(selected_cash_value)}
                  </b>
                </Typography>
              </Grid>
              {selected_mdate === "N/A" && selected_taken === true ? (
                <Grid item xs={6} md={6}>
                  <Typography
                    sx={{ display: "inline-flex", color: "brown" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      Momo deposits used for another date
                      <br /> (select date to match cash deposit date)
                    </b>
                  </Typography>
                </Grid>
              ) : (
                <Grid item xs={6} md={6}>
                  <Typography
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      {formatDateToYearMonthDay(
                        new Date(
                          rematched_date ? rematched_date : selected_mdate
                        )
                      )}
                    </b>
                  </Typography>
                  <Typography
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      Momo Deposits:{" "}
                      {currencyFormat.format(
                        rematched_momo_bal
                          ? rematched_momo_bal
                          : selected_momo_bal
                      )}
                    </b>
                  </Typography>
                </Grid>
              )}

              <Grid item xs={12} md={12} sx={{ m: 2 }}>
                <Accordion sx={{ borderRadius: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      subtitle="h5"
                      sx={{ color: "black" }}
                    >
                      <b>Reason for setting different date?</b>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TextField
                      size="small"
                      value={rematch_reason}
                      multiline
                      rows={4}
                      fullWidth
                      onChange={(e) => setRematch_reason(e.target.value)}
                      placeholder="type here"
                    />
                  </AccordionDetails>
                </Accordion>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography
                  sx={{ textAlign: "center", mb: "5px" }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Select actual date of the momo deposit</b>
                </Typography>
                <Box sx={{ display: "inline-flex" }}>
                  <TextField
                    type="date"
                    required
                    helperText="Search date"
                    size="small"
                    name="filter_datematch"
                    value={filter_datematch}
                    onChange={(e) => setFilter_datematch(e.target.value)}
                    sx={{ marginRight: 4 }}
                  />
                  <IconButton onClick={filterHandleRematch}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton onClick={noFil}>
                    <CancelIcon />
                  </IconButton>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxHeight: 240,
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  {momo_for_rematch.map((twos) => (
                    <Chip
                      sx={{
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                        padding: 4,
                        margin: 1,
                        minWidth: 0,
                        "&:hover": {
                          boxShadow:
                            "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        },
                      }}
                      size="small"
                      label={
                        <Typography
                          sx={{ display: "block", m: 1 }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <div>
                            <b>
                              {/* {formatDateToYearMonthDay(new Date(twos.transaction_date))} */}
                              {formatDateToYearMonthDay(new Date(twos.date))}
                            </b>
                          </div>
                          <div>
                            {/* <b>{currencyFormat.format(twos.transaction_id)}</b> */}
                            <b>{currencyFormat.format(twos.momo_bal)}</b>
                          </div>
                        </Typography>
                      }
                      onClick={() =>
                        rematchChosen(twos.id, twos.date, twos.momo_bal)
                      }
                    />
                  ))}
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ marginRight: "auto" }}>
              <Button
                size="medium"
                sx={{
                  borderRadius: 3,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                  margin: 1,
                  minWidth: 0,
                  "&:hover": {
                    boxShadow:
                      "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  },
                }}
                color="error"
                onClick={handleCancelRematch}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openn}
          onClick={handleCloseBackdrop}
        >
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
          </div>
        </Backdrop>
      </LocalizationProvider>
    </>
  );
};

const InsideAccount = (props) => {
  const current_balance = props.current_balance;
  const account_name = props.account_name;
  const id = props.id;
  const open_date = props.open_date;
  const purpose = props.purpose;
  const [accounts, setAccounts] = useState([]);
  const [exp_accounts, setExp_accounts] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const [withOpen, setWithOpen] = useState(false);
  const [traOpen, setTraOpen] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const { permissions } = useContext(AuthContext);

  const fetchAccountsSociety = () => {
    api
      .get(`/account/society/transfer/all/${props.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAccounts(response.data?.rr);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchExpenseAccountsSociety = () => {
    api
      .get(`/account/society/transfer/all/expense/${props.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setExp_accounts(response.data?.rr);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAccountsSociety();
    fetchExpenseAccountsSociety();
  }, []);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const handleDeposit = () => {
    setSaveOpen(true);
  };

  const handleWithdraw = () => {
    setWithOpen(true);
  };

  const handleTransfer = () => {
    setTraOpen(true);
  };

  const closeTransfer = () => {
    formikkk.handleReset();
    setTraOpen(false);
  };

  const closeWithdraw = () => {
    formikk.handleReset();
    setWithOpen(false);
  };

  const closeDeposit = () => {
    formik.handleReset();
    setSaveOpen(false);
  };

  const fetchTrs = () => {
    api
      .get(`/transactions/transactions/society/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setTransactions(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const formik = useFormik({
    initialValues: {
      to_account_id: null,
      amount: null,
      narration: "",
      society_account_id: id,
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Specify Amount To Spend").min(0),
      narration: Yup.string("Must be characters").required(
        "Specify the purpose of this transaction"
      ),
    }),
    onSubmit: (values) => {
      api
        .post("/transactions/society/transfer/expense", values, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik.handleReset();
          closeDeposit();
          fetchTrs();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  });

  const formikk = useFormik({
    initialValues: {
      transactiontype_id: 2,
      amount: null,
      narration: "",
      society_account_id: id,
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Specify Amount To Withdraw").min(0),
      narration: Yup.string("Must be characters"),
    }),
    onSubmit: (values) => {
      api
        .post("/transactions/transaction/withdraw/society", values, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formikk.handleReset();
          closeWithdraw();
          fetchTrs();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  });

  const formikkk = useFormik({
    initialValues: {
      to_account_id: null,
      amount: null,
      society_account_id: id,
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Specify Amount To Transfer").min(0),
    }),
    onSubmit: (values) => {
      api
        .post("/transactions/society/transfer", values, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          closeTransfer();
          fetchTrs();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  });

  useEffect(() => {
    fetchTrs();
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const columns = [
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) => (
        <FormatedDate value={params.row.transaction_date} />
      ),
    },
    {
      field: "narration",
      headerName: "Narration",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "debit",
      headerName: "Debit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.transactiontype_id === 2
          ? currencyFormat.format(params.row.amount)
          : 0,
      editable: true,
    },
    {
      field: "credit",
      headerName: "Credit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.transactiontype_id === 1
          ? currencyFormat.format(params.row.amount)
          : 0,
      editable: true,
    },
    {
      field: "balance",
      headerName: "Account Balance",
      flex: 1,
      width: 70,
      renderCell: (params) => currencyFormat.format(params.row.balance),
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
      width: 70,
    },
    {
      field: "transactiontype_id",
      headerName: "Type",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "amount",
      headerName: "Amount(GH₵)",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
      width: 70,
    },
  ];

  const handleClose = () => {
    props.setAlert();
    props.setOpen();
  };

  return (
    <div>
      <Item>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button onClick={handleClose} variant="contained" color="warning">
            Close
          </Button>
          <Typography>
            Current Balance:{" "}
            <span style={{ fontWeight: "700" }}>
              {currencyFormat.format(current_balance)}
            </span>
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "700", color: "darkblue" }}
          >
            {account_name}
          </Typography>
          <Typography>Open date: {open_date}</Typography>
        </Box>

        <Box
          sx={{
            display: "flex-end",
          }}
        >
          {permissions && permissions.create_bank_transactions === true ? (
            <ButtonGroup
              variant="contained"
              aria-label="outlined primary button group"
            >
              {/* <Button onClick={handleDeposit}>Deposit</Button>
                    <Button onClick={handleWithdraw}>Withdraw</Button> */}
              <Button onClick={handleTransfer}>Transfer</Button>
              <Button onClick={handleDeposit}>Spend</Button>
            </ButtonGroup>
          ) : null}
        </Box>
        <Box m="40px 0 0 0" height="75vh" paddingBottom="35px">
          {permissions && permissions.view_bank_transactions === true ? (
            <>
              <Typography variant="h3" sx={{ marginBottom: "10px" }}>
                Current Transactions
              </Typography>
              <DataGrid
                rows={transactions}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row.transaction_id}
                slots={{ toolbar: GridToolbar }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      transaction_id: false,
                      amount: false,
                      username: false,
                      transactiontype_id: false,
                    },
                  },
                }}
              />
            </>
          ) : null}
        </Box>
      </Item>
      <Dialog open={saveOpen} onClose={closeDeposit}>
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>Spend</DialogContentText>
            {/* <Select
                  required
                  variant='outlined'
                  id="to_account_id"
                  label="Transfer To"
                  value={formik.values.to_account_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.to_account_id && Boolean(formik.errors.to_account_id)}
                  helperText={formik.touched.to_account_id && formik.errors.to_account_id}
                  name="to_account_id"
                  >
                      {exp_accounts.map(account => (
                          <MenuItem value={account.id} key={account.id}>
                            {account.account_name}
                          </MenuItem>
                      ))}
              </Select> */}
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={exp_accounts}
              sx={{ width: 300 }}
              getOptionLabel={(option) => `${option.account_name}`}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, value) => {
                if (value) {
                  formik.setFieldValue("to_account_id", value.id);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Expense Account" />
              )}
            />
            <TextField
              margin="dense"
              id="amount"
              name="amount"
              label="Amount (GHS)"
              onChange={formik.handleChange}
              value={formik.values.amount}
              onBlur={formik.handleBlur}
              error={formik.touched.amount && Boolean(formik.errors.amount)}
              helperText={formik.touched.amount && formik.errors.amount}
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              margin="dense"
              id="narration"
              name="narration"
              label="Narration (optional)"
              onChange={formik.handleChange}
              type="text"
              value={formik.values.narration}
              onBlur={formik.handleBlur}
              error={
                formik.touched.narration && Boolean(formik.errors.narration)
              }
              helperText={formik.touched.narration && formik.errors.narration}
              fullWidth
              variant="outlined"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDeposit}>Cancel</Button>
            <Button type="submit">Deposit</Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* withdrawal */}

      <Dialog open={withOpen} onClose={closeWithdraw}>
        <form onSubmit={formikk.handleSubmit}>
          <DialogTitle>Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>Withdraw</DialogContentText>
            <TextField
              margin="dense"
              id="amount"
              name="amount"
              label="Amount to withdraw"
              onChange={formikk.handleChange}
              value={formikk.values.amount}
              onBlur={formikk.handleBlur}
              error={formikk.touched.amount && Boolean(formikk.errors.amount)}
              helperText={formikk.touched.amount && formikk.errors.amount}
              type="number"
              fullWidth
              variant="outlined"
            />

            <TextField
              margin="dense"
              id="narration"
              name="narration"
              label="Narration (optional)"
              onChange={formikk.handleChange}
              type="text"
              value={formikk.values.narration}
              onBlur={formikk.handleBlur}
              error={
                formikk.touched.narration && Boolean(formikk.errors.narration)
              }
              helperText={formikk.touched.narration && formikk.errors.narration}
              fullWidth
              variant="outlined"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeWithdraw}>Cancel</Button>
            <Button type="submit">Withdraw</Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Transfer */}

      <Dialog open={traOpen} onClose={closeTransfer}>
        <form onSubmit={formikkk.handleSubmit}>
          <DialogTitle>Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>Transfer</DialogContentText>
            <Select
              required
              variant="outlined"
              id="to_account_id"
              label="Transfer To"
              value={formikkk.values.to_account_id}
              onChange={formikkk.handleChange}
              onBlur={formikkk.handleBlur}
              error={
                formikkk.touched.to_account_id &&
                Boolean(formikkk.errors.to_account_id)
              }
              helperText={
                formikkk.touched.to_account_id && formikkk.errors.to_account_id
              }
              name="to_account_id"
            >
              {accounts.map((account) => (
                <MenuItem value={account.id} key={account.id}>
                  {account.account_name}
                </MenuItem>
              ))}
            </Select>

            <TextField
              margin="dense"
              id="amount"
              name="amount"
              label="Amount"
              onChange={formikkk.handleChange}
              type="text"
              value={formikkk.values.amount}
              onBlur={formikkk.handleBlur}
              error={formikkk.touched.amount && Boolean(formikkk.errors.amount)}
              helperText={formikkk.touched.amount && formikkk.errors.amount}
              fullWidth
              variant="outlined"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeTransfer}>Cancel</Button>
            <Button type="submit">Transfer</Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

const InsideLedgerAccount = (props) => {
  const current_balance = props.current_balance;
  const account_name = props.account_name;
  const id = props.id;
  const open_date = props.open_date;
  const purpose = props.purpose;
  const [transactions, setTransactions] = useState([]);
  const { permissions } = useContext(AuthContext);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  useEffect(() => {
    api
      .get(`/transactions/transactions/society/expense/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setTransactions(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const columns = [
    {
      field: "transaction_date",
      headerName: "DateTime",
      width: 130,
      cellClassName: "name-column--cell",
      renderCell: (params) => (
        <FormatedDate value={params.row.transaction_date} />
      ),
    },
    {
      field: "amount",
      headerName: "Amount(GHS)",
      width: 100,
      renderCell: (params) => currencyFormat.format(params.row.amount),
    },
    {
      field: "narration",
      headerName: "Purpose",
      width: 550,
    },
    {
      field: "balance",
      headerName: "Account Balance",
      width: 130,
      renderCell: (params) => currencyFormat.format(params.row.balance),
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
      width: 70,
    },
    {
      field: "transactiontype_id",
      headerName: "Type",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
      width: 70,
    },
  ];

  const handleClose = () => {
    props.setAlert();
    props.setOpen();
  };

  return (
    <div>
      <Item>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button onClick={handleClose} variant="contained" color="warning">
            Close
          </Button>
          <Typography>
            Current Balance:{" "}
            <span style={{ fontWeight: "700" }}>
              {currencyFormat.format(current_balance)}
            </span>
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "700", color: "darkblue" }}
          >
            {account_name}
          </Typography>
          <Typography>Open date: {open_date}</Typography>
        </Box>

        <Box m="40px 0 0 0" height="75vh" paddingBottom="35px">
          {permissions && permissions.view_bank_transactions === true ? (
            <>
              <Typography variant="h3" sx={{ marginBottom: "10px" }}>
                Current Transactions
              </Typography>
              <DataGrid
                rows={transactions}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row.transaction_id}
                slots={{ toolbar: GridToolbar }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      transaction_id: false,
                      username: false,
                      transactiontype_id: false,
                    },
                  },
                }}
              />
            </>
          ) : null}
        </Box>
      </Item>
    </div>
  );
};

const LedgersAccount = (props) => {
  const [accounts, setAccounts] = useState([]);
  const [open, setOpen] = useState();
  const [edit, setEdit] = useState(false);
  const [alert, setAlert] = useState();
  const { permissions } = useContext(AuthContext);
  const [total, setTotal] = useState();

  const fetchAccountsSociety = () => {
    api
      .get(`/account/society/all/expense/${props.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAccounts(response.data?.Accounts);
        setTotal(response.data?.Total);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAccountsSociety();
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: "flex", padding: "4px" }}>
          <Typography variant="h5" sx={{ color: "red", mr: 4 }}>
            Total:
          </Typography>
          <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
            Current balance total: {currencyFormat.format(total)}{" "}
          </Typography>
        </div>
      </div>
    );
  };

  // console.log(accounts);

  const columns = [
    {
      field: "account_name",
      headerName: "Ledger Name",
      flex: 1,
    },
    {
      field: "open_date",
      headerName: "Open Date",
      flex: 1,
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "current_balance",
      headerName: "Current Amount(GHS)",
      flex: 1,
      renderCell: (params) => currencyFormat.format(params.row.current_balance),
    },
    {
      field: "edit",
      type: "actions",
      headerName: "Open & Update",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          onClick={() => editAccount(params)}
          label="Open"
        />,
      ],
    },
    {
      field: "do",
      type: "actions",
      headerName: "View",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<FileOpenIcon />}
          onClick={() =>
            handleOpenAccounts(
              params.row.id,
              params.row.account_name,
              params.row.current_balance,
              params.row.open_date,
              params.row.purpose
            )
          }
          label="Open"
        />,
      ],
    },
  ];

  const editAccount = (params) => {
    formik.setFieldValue("id", params.row.id);
    formik.setFieldValue("account_name", params.row.account_name);
    formik.setFieldValue("purpose", params.row.description);
    formik.setFieldValue("in_out", params.row.in_out);
    formik.setFieldValue("in_ex", params.row.in_ex);
    formik.setFieldValue("as_li", params.row.as_li);
    setEdit(true);
  };

  const handleOpenAccounts = (
    id,
    account_name,
    current_balance,
    open_date,
    purpose
  ) => {
    if (open == null) {
      setOpen(
        <InsideLedgerAccount
          setAlert={setAlert}
          setOpen={setOpen}
          id={id}
          account_name={account_name}
          current_balance={current_balance}
          open_date={open_date}
          purpose={purpose}
        />
      );
      setAlert();
    } else {
      setAlert(
        <Alert severity="error">
          Close Current tab before opening another tab
        </Alert>
      );
    }
  };

  const [openn, setOpenn] = React.useState(false);
  const handleClose = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const formik = useFormik({
    initialValues: {
      id: null,
      account_name: "",
      purpose: "",
      in_out: "",
      in_ex: "",
      as_li: "",
    },
    validationSchema: Yup.object({
      account_name: Yup.string().required("Specify Ledger name"),
      purpose: Yup.string("Must be characters"),
    }),
    onSubmit: (values) => {
      handleOpen();
      const data = new FormData()
      data.append('society_id', props.id)
      if(values.id){
        data.append('id', values.id)
      }
      data.append('account_name', values.account_name)
      data.append('purpose', values.purpose)
      data.append('in_out', values.in_out)
      data.append('in_ex', values.in_ex)
      data.append('as_li', values.as_li)
      
      api
        .post("/account/society/account/expense", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik.handleReset();
          fetchAccountsSociety();
          setEdit(false)
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          handleClose();
        });
    },
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Typography
            variant="h3"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            sx={{ textAlign: "center", m: 1 }}
          >
            <b>Expense Records</b>
          </Typography>
          {alert}
        </Grid>
        <Grid item xs={12} md={4}>
          {permissions && permissions.create_bank_accounts === true ? (
            <>
              <Typography
                sx={{ textAlign: "center" }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{edit? 'Update Book': 'Register New Expense Record book'}</b>
              </Typography>
              <form onSubmit={formik.handleSubmit}>
                <TextField
                  margin="dense"
                  id="account_name"
                  name="account_name"
                  label="Ledger Name"
                  onChange={formik.handleChange}
                  value={formik.values.account_name}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.account_name &&
                    Boolean(formik.errors.account_name)
                  }
                  helperText={
                    formik.touched.account_name && formik.errors.account_name
                  }
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  margin="dense"
                  id="purpose"
                  name="purpose"
                  label="Description (optional)"
                  multiline
                  rows={4}
                  onChange={formik.handleChange}
                  value={formik.values.purpose}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.purpose && Boolean(formik.errors.purpose)
                  }
                  helperText={formik.touched.purpose && formik.errors.purpose}
                  fullWidth
                  variant="outlined"
                />
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={formik.values.in_out}
                  onChange={formik.handleChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={formik.values.in_ex}
                  onChange={formik.handleChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={formik.values.as_li}
                  onChange={formik.handleChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
                <Button
                  sx={{ marginTop: "10px" }}
                  variant="contained"
                  color="success"
                  type="submit"
                >
                  Finish
                </Button>
              </form>
            </>
          ) : null}

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openn}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
        <Grid item xs={12} md={8}>
          <DataGrid
            rows={accounts}
            columns={columns}
            checkboxSelection
            autoHeight
            sx={{ m: 1 }}
            getRowId={(row) => row.id}
            slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
            sortingOrder={["desc", "asc"]}
            sortModel={[
              {
                field: "id",
                sort: "desc",
              },
            ]}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  id: false,
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          {open}
        </Grid>
      </Grid>
    </>
  );
};

const BankAccounts = (props) => {
  const [accounts, setAccounts] = useState([]);
  const [open, setOpen] = useState();
  const [edit, setEdit] = useState(false);
  const [alert, setAlert] = useState();
  const { permissions } = useContext(AuthContext);
  const [total, setTotal] = useState();

  const fetchAccountsSociety = () => {
    api
      .get(`/account/society/all/${props.id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAccounts(response.data?.Accounts);
        setTotal(response.data?.Total);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAccountsSociety();
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: "flex", padding: "4px" }}>
          <Typography variant="h5" sx={{ color: "red", mr: 4 }}>
            Total:
          </Typography>
          <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
            Current balance total: {currencyFormat.format(total)}{" "}
          </Typography>
        </div>
      </div>
    );
  };

  // console.log(accounts);

  const columns = [
    {
      field: "account_name",
      headerName: "Account Name",
      flex: 1,
    },
    {
      field: "type",
      headerName: "Account Provider",
      flex: 1,
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "number",
      headerName: "Account Number",
      flex: 1,
    },
    {
      field: "current_balance",
      headerName: "Current Amount(GHS)",
      flex: 1,
      renderCell: (params) => currencyFormat.format(params.row.current_balance),
    },
    {
      field: "edit",
      type: "actions",
      headerName: "Open & Update",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          onClick={() => editAccount(params)}
          label="Open"
        />,
      ],
    },
    {
      field: "do",
      type: "actions",
      headerName: "View",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<FileOpenIcon />}
          onClick={() =>
            handleOpenAccounts(
              params.row.id,
              params.row.account_name,
              params.row.current_balance,
              params.row.open_date,
              params.row.purpose
            )
          }
          label="Open"
        />,
      ],
    },
  ];

  const editAccount = (params) => {
    formik.setFieldValue("id", params.row.id);
    formik.setFieldValue("account_name", params.row.account_name);
    formik.setFieldValue("account_number", params.row.account_number?params.row.account_number:"");
    formik.setFieldValue("type", params.row.type);
    formik.setFieldValue("name", params.row.name);
    formik.setFieldValue("purpose", params.row.purpose);
    formik.setFieldValue("in_out", params.row.in_out);
    formik.setFieldValue("in_ex", params.row.in_ex);
    formik.setFieldValue("as_li", params.row.as_li);
    setEdit(true);
  };

  const handleOpenAccounts = (
    id,
    account_name,
    current_balance,
    open_date,
    purpose
  ) => {
    if (open == null) {
      setOpen(
        <InsideAccount
          setAlert={setAlert}
          setOpen={setOpen}
          id={id}
          account_name={account_name}
          current_balance={current_balance}
          open_date={open_date}
          purpose={purpose}
        />
      );
      setAlert();
    } else {
      setAlert(
        <Alert severity="error">
          Close Current tab before opening another tab
        </Alert>
      );
    }
  };

  const [openn, setOpenn] = React.useState(false);
  const handleClose = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const formik = useFormik({
    initialValues: {
      id: 0,
      account_name: "",
      type: "",
      account_number: "",
      name: "",
      society_id: props.id,
      purpose: "",
      in_out: "",
      in_ex: "",
      as_li: "",
    },
    validationSchema: Yup.object({
      account_name: Yup.string().required("Specify Bank Account name"),
      purpose: Yup.string("Must be characters"),
    }),
    onSubmit: (values) => {
      handleOpen();
      api
        .post("/account/society/account", values, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik.handleReset();
          fetchAccountsSociety();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          handleClose();
        });
    },
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Typography
            variant="h3"
            sx={{ textAlign: "center", m: 1 }}
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>Bank/Wallet Accounts</b>
          </Typography>
          {alert}
        </Grid>
        <Grid item xs={12} md={4}>
          {permissions && permissions.create_bank_accounts === true ? (
            <>
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                sx={{ textAlign: "center" }}
              >
                <b>
                  {edit
                    ? "Edit Account Details"
                    : "Register New Bank/Wallet Account"}
                </b>
              </Typography>
              <form onSubmit={formik.handleSubmit}>
                <TextField
                  margin="dense"
                  id="account_name"
                  name="account_name"
                  label="Account Name"
                  onChange={formik.handleChange}
                  value={formik.values.account_name}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.account_name &&
                    Boolean(formik.errors.account_name)
                  }
                  helperText={
                    formik.touched.account_name && formik.errors.account_name
                  }
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  margin="dense"
                  id="type"
                  name="type"
                  label="Account Provider"
                  placeholder="Fedelity Bank/MTN etc"
                  onChange={formik.handleChange}
                  value={formik.values.type}
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  margin="dense"
                  id="account_number"
                  name="account_number"
                  label="Account Number"
                  onChange={formik.handleChange}
                  value={formik.values.account_number}
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  margin="dense"
                  id="name"
                  name="name"
                  label="Name on Account"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  margin="dense"
                  id="purpose"
                  name="purpose"
                  label="Purpose of Account (optional)"
                  multiline
                  rows={4}
                  onChange={formik.handleChange}
                  value={formik.values.purpose}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.purpose && Boolean(formik.errors.purpose)
                  }
                  helperText={formik.touched.purpose && formik.errors.purpose}
                  fullWidth
                  variant="outlined"
                />
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={formik.values.in_out}
                  onChange={formik.handleChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={formik.values.in_ex}
                  onChange={formik.handleChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={formik.values.as_li}
                  onChange={formik.handleChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
                <Button
                  sx={{ marginTop: "10px" }}
                  variant="contained"
                  color="success"
                  type="submit"
                >
                  Finish
                </Button>
              </form>
            </>
          ) : null}

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openn}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
        <Grid item xs={12} md={8}>
          <DataGrid
            rows={accounts}
            columns={columns}
            checkboxSelection
            autoHeight
            sx={{ marginTop: 3, minWidth: 700 }}
            getRowId={(row) => row.id}
            slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
            sortingOrder={["desc", "asc"]}
            sortModel={[
              {
                field: "id",
                sort: "desc",
              },
            ]}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  id: false,
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          {open}
        </Grid>
      </Grid>
    </>
  );
};

const IttemCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "5px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  // width: '100%',
  borderRadius: "17px",
}));

const Ittem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  // width: '100%',
  borderRadius: "10px",
}));

const Ittemm = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  width: "100%",
  borderRadius: "10px",
}));

const Itteemm = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  width: "100%",
  borderRadius: "10px",
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yPropsInvest(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Payment = ({ item, fetchData }) => {
  const [open, setOpen] = useState(false);
  const [banks_accounts, setBanks_accounts] = useState([]);
  const [bank_id, setBank_id] = useState(null);
  const [ledgers, setLedgers] = useState([]);
  const [ledger_id, setLedger_id] = useState(null);
  const [amount, setAmount] = useState(null);
  const [loading, setLoading] = useState(false);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setBank_id(null);
    setLedger_id(null);
    setAmount(null);
  };

  const handleInvestmentRepayment = () => {
    setLoading(true);
    const data = new FormData();
    data.append("bank_id", bank_id);
    data.append("investor_id", item.investor_id);
    data.append("investment_id", item.investment_id);
    data.append("ledger_id", ledger_id);
    data.append("amount", amount);

    api
      .post("/investors/society/investments/transfer/investor", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleClose();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchAccounts();
        fetchData();
        setLoading(false);
      });
  };

  const fetchAccounts = () => {
    api
      .get(`/account/society/all/${item.society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setBanks_accounts(response.data?.Accounts);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/account/one/ledger/account/${item.society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLedgers(response.data?.ledgers);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxHeight: "80vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <React.Fragment>
      <Chip
        size="medium"
        label={
          <Typography
            variant="subtitle"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>Settle</b>
          </Typography>
        }
        sx={{
          borderRadius: 2,
          ml: "40%",
          mr: "40%",
          boxShadow:
            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
          backgroundColor: "orange",
          color: "#000",
          "&:hover": {
            boxShadow:
              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#14213d",
            color: "#fff",
          },
        }}
        onClick={handleOpen}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h4"
                textAlign="center"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{currencyFormat.format(item.expected_income)}</b>
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <Ittem>
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  {banks_accounts?.map((bank) => (
                    <Chip
                      size="small"
                      disabled={bank.current_balance < item.expected_income}
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>
                            {bank.account_name} (
                            {currencyFormat.format(bank.current_balance)})
                          </b>
                        </Typography>
                      }
                      sx={{
                        borderRadius: 2,
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          bank.id === bank_id ? "green" : "white",
                        color: "#000",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "green",
                          color: "#fff",
                        },
                      }}
                      onClick={() => setBank_id(bank.id)}
                    />
                  ))}
                </Box>
              </Ittem>
            </Grid>
            <Grid item xs={12} md={12}>
              {bank_id ? (
                ledgers ? (
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                  >
                    {ledgers.map((ledg) => (
                      <>
                        <ListItem
                          alignItems="flex-start"
                          secondaryAction={
                            <IconButton
                              onClick={() => setLedger_id(ledg.id)}
                              edge="end"
                              aria-label="comments"
                            >
                              <CheckCircle
                                color={
                                  ledg.id === ledger_id ? "success" : "primary"
                                }
                              />
                            </IconButton>
                          }
                        >
                          <ListItemText
                            primary={ledg.account_name}
                            secondary={
                              <Box sx={{ display: "block" }}>
                                <div>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    <b>{ledg.description}</b>
                                  </Typography>
                                </div>
                              </Box>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </>
                    ))}
                  </List>
                ) : (
                  <Typography
                    textAlign="center"
                    sx={{ m: 3 }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>No ledgers available</b>
                  </Typography>
                )
              ) : null}
            </Grid>
            <Grid item xs={12} md={12}>
              <Box>
                <Chip
                  size="small"
                  label={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Cancel</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    ml: "auto",
                    mr: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "red",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "green",
                      color: "#000",
                    },
                  }}
                  onClick={handleClose}
                />
                <Chip
                  size="small"
                  disabled={!bank_id || !ledger_id || loading}
                  label={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Complete</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    ml: "auto",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "green",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "white",
                      color: "#000",
                    },
                  }}
                  onClick={handleInvestmentRepayment}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </React.Fragment>
  );
};

const Investments = ({ id, name }) => {
  const [open_modal, setOpen_modal] = useState(false);
  const [open_modal_inves, setOpen_modal_inves] = useState(false);
  const [open_modal_transfer, setOpen_modal_transfer] = useState(false);
  const [open_modal_settle, setOpen_modal_settle] = useState(false);
  const [open_modal_print, setOpen_modal_print] = useState(false);
  const [open_modal_trs, setOpen_modal_trs] = useState(false);
  const [open_modal_investment, setOpen_modal_investment] = useState(false);
  const [hold_investor, setHold_investors] = useState([]);
  const [hold_income_investor, setHold_income_investor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("No selected file");
  const [investors, setInvestors] = useState([]);
  const [payback, setPayback] = useState(0);
  const [payback_interest, setPayback_interest] = useState(0);
  const [pre_finance_process, setPre_finance_process] = useState([]);
  const [society_data, setSociety_data] = useState([]);
  const [banks_accounts, setBanks_accounts] = useState([]);
  const [bank, setBank] = useState(null);
  const [amount, setAmount] = useState(null);
  const [narration, setNarration] = useState("");
  const [transfer_date, setTransfer_date] = useState(dayjs);
  const [hold_investor_id_trs, setHold_investor_id_trs] = useState(null);
  const [amount_trs, setAmount_trs] = useState(null);
  const [narration_trs, setNarration_trs] = useState("");
  const [date_trs, setDate_trs] = useState(dayjs);
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);
  const [hold_row, setHold_row] = useState();
  const [expanded, setExpanded] = useState(false);
  const [edit, setEdit] = useState(0);
  const [transaction_type, setTransaction_type] = useState("");
  const [trs_id, setTrs_id] = useState(0);
  const [inves_type, setInves_type] = useState("");
  const [commodities, setCommodities] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [investment_detaila, setInvestment_detaila] = useState([]);
  const [get_crops, setGet_crops] = useState(false);
  const [pre_or_equity, setPre_or_equity] = useState("");
  const [open_re, setOpen_re] = useState(false);
  const [banks_accounts_re, setBanks_accounts_re] = useState([]);
  const [bank_id_re, setBank_id_re] = useState(null);
  const [ledgers_re, setLedgers_re] = useState([]);
  const [ledger_id_re, setLedger_id_re] = useState(null);
  const [investor_id_re, setInvestor_id_re] = useState(null);
  const [investment_id_re, setInvestment_id_re] = useState(null);
  const [amount_re, setAmount_re] = useState(null);
  const [max, setMax] = useState(false);
  const [price, setPrice] = useState(null);
  const [manipulate, setManipulates] = useState([]);
  const [addons, setAddons] = useState([]);
  const [kind_cash, setKind_cash] = useState(false);
  const [left_amount, setLeft_amount] = useState(null);
  const [grade_a_100, setGrade_a_100] = useState(0);
  const [grade_a_50, setGrade_a_50] = useState(0);
  const [grade_b_100, setGrade_b_100] = useState(0);
  const [grade_b_50, setGrade_b_50] = useState(0);
  const [grade_c_100, setGrade_c_100] = useState(0);
  const [grade_c_50, setGrade_c_50] = useState(0);
  const [where, setWhere] = useState(0);

  useEffect(() => {
    if (pre_or_equity === "Pre Finance") {
      setKind_cash(true);
    } else {
      setKind_cash(false);
    }
  }, [pre_or_equity]);

  const fill_and_proccess = (commodity_id, grade, unit) => {};

  const handleAddBag = (commodity_id, grade, unit, action) => {
    // console.log((left_amount?left_amount:
    //   investment_detaila?.investment_details
    //   ?.amount_investing) / (investment_detaila?.investment_details?.grade_a * 100))

    const data = new FormData();
    data.append("commodity_id", commodity_id);
    data.append("grade", grade);
    data.append("unit", unit);
    data.append(
      "price",
      left_amount
        ? left_amount
        : investment_detaila?.investment_details?.amount_investing
    );
    data.append("action", action);
    data.append("commodity_id", commodity_id);
    data.append(
      "initial_amount",
      investment_detaila?.investment_details?.amount_investing
    );

    api
      .post("/investors/get/commodities/recalculation", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLeft_amount(response.data?.now_price);

        if (response.data === "Bags Exceeded") {
          toast.error("Bags Exceeded");
        } else {
          if (grade === "Grade A") {
            if (unit === 100) {
              setGrade_a_100((prev) =>
                action === "+"
                  ? prev + 1
                  : action === "-"
                  ? prev - 1
                  : Number(action)
              );
            } else {
              setGrade_a_50((prev) =>
                action === "+"
                  ? prev + 1
                  : action === "-"
                  ? prev - 1
                  : Number(action)
              );
            }
          } else if (grade === "Grade B") {
            if (unit === 100) {
              setGrade_b_100((prev) =>
                action === "+"
                  ? prev + 1
                  : action === "-"
                  ? prev - 1
                  : Number(action)
              );
            } else {
              setGrade_b_50((prev) =>
                action === "+"
                  ? prev + 1
                  : action === "-"
                  ? prev - 1
                  : Number(action)
              );
            }
          } else if (grade === "Grade C") {
            if (unit === 100) {
              setGrade_c_100((prev) =>
                action === "+"
                  ? prev + 1
                  : action === "-"
                  ? prev - 1
                  : Number(action)
              );
            } else {
              setGrade_c_50((prev) =>
                action === "+"
                  ? prev + 1
                  : action === "-"
                  ? prev - 1
                  : Number(action)
              );
            }
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Function to handle removing a bag
  const handleRemoveBag = (grade, unit) => {
    setManipulates((prev) => {
      const existingItem = prev.find(
        (item) => item.grade === grade && item.unit === unit
      );
      if (existingItem) {
        // Decrement the number of bags, and remove if it reaches zero
        const updatedList = prev
          .map((item) =>
            item.grade === grade && item.unit === unit
              ? { ...item, number_of_bags: item.number_of_bags - 1 }
              : item
          )
          .filter((item) => item.number_of_bags > 0); // Remove items with zero bags
        return updatedList;
      }
      return prev;
    });
  };

  const doMax = () => {
    setMax((prev) => !prev);
    setAmount_re(investment_detaila?.investment_details?.amount_left);
  };

  const handleOpen_re = (investor_id, investment_id) => {
    setOpen_re(true);
    setInvestor_id_re(investor_id);
    setInvestment_id_re(investment_id);
  };
  const handleClose_re = () => {
    setOpen_re(false);
    setBank_id_re(null);
    setLedger_id_re(null);
    setAmount_re(null);
  };

  const handleInvestmentRepayment = () => {
    setLoading(true);
    const data = new FormData();
    data.append("bank_id", bank_id_re);
    data.append("investor_id", investor_id_re);
    data.append("investment_id", investment_id_re);
    data.append("ledger_id", ledger_id_re);
    data.append("amount", amount_re);
    data.append("max", max);

    api
      .post("/investors/society/investments/transfer/investor", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleClose_re();
        handleOneInvestor(investor_id_re, hold_investor);
        api
          .get(
            `/investors/get/view/trs/equity/and/capital_finance/${investment_id_re}`,
            {
              headers: {
                Authorization: "Bearer " + fetchToken(),
              },
            }
          )
          .then(function (response) {
            // console.log(response.data)
            setInvestment_detaila(response.data);
            setOpen_modal_investment(true);
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchAccounts();
        fetchData();
        setLoading(false);
      });
  };

  const fetchAccounts = () => {
    api
      .get(`/account/society/all/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setBanks_accounts_re(response.data?.Accounts);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/account/one/ledger/account/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLedgers_re(response.data?.ledgers);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const viewInvestment = (row, id_type) => {
    if (row.description === "Pre Finance") {
      setPre_or_equity(row.description);
      api
        .get(
          `/investors/get/view/trs/pre_finance/${
            id_type === "all" ? row.investment_id : row.id
          }`,
          {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }
        )
        .then(function (response) {
          // console.log(response.data);
          setInvestment_detaila(response.data);
          setOpen_modal_investment(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setPre_or_equity(row.description);
      api
        .get(
          `/investors/get/view/trs/equity/and/capital_finance/${
            id_type === "all" ? row.investment_id : row.id
          }`,
          {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }
        )
        .then(function (response) {
          // console.log(reponse.data)
          setInvestment_detaila(response.data);
          setOpen_modal_investment(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const closeOpenModalInvestment = () => {
    setOpen_modal_investment(false);
    setInvestment_detaila([]);
  };

  function formatDateToYearMonthDayTime(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${day}${suffix} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
  }

  const handleAccountTransactions = () => {
    setLoading(true);
    const data = new FormData();
    data.append("amount", amount_trs);
    data.append("narration", narration_trs);
    data.append("date", date_trs);
    data.append("investor_id", hold_investor_id_trs);
    data.append(
      "transactiontype_id",
      transaction_type === "Deposit" ? 1 : transaction_type === "Edit" ? 0 : 2
    );
    data.append("trs_id", trs_id);
    data.append("society_id", id);

    api
      .post("/investors/transaction/investor/account", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        closeAccountTransact();
        handleOneInvestor(hold_investor_id_trs, hold_investor);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchData();
        setLoading(false);
      });
  };

  const handleEdit = (row) => {
    formik_inves.setFieldValue("investment_type", row.description);
    formik_inves.setFieldValue("investment_amount", row.amount_investing);
    formik_inves.setFieldValue("investment_period", row.months_period);
    formik_inves.setFieldValue("interest_type", row.interest_type);
    formik_inves.setFieldValue("interest", row.interest);
    formik_inves.setFieldValue("terms_and_conditions", row.terms);
    setExpanded(true);
    setEdit(row.id);
  };

  const deleteInvestment = (investment_id, investor_id) => {
    api
      .delete(`/investors/society/investments/delete/${investment_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleOneInvestor(investor_id, hold_investor);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchData();
      });
  };

  const handleChangeExpand = () => {
    setExpanded(false);
    setEdit(0);
    formik_inves.handleReset();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const transferFunds = () => {
    setOpen_modal_transfer(true);
  };

  const settleFunds = () => {
    setOpen_modal_settle(true);
  };

  const printReceipt = (data) => {
    setOpen_modal_print(true);
    setHold_row(data);
  };

  const accountTransact = (
    tt_type,
    investor_id,
    amount,
    narration,
    date,
    trs_id
  ) => {
    setOpen_modal_trs(true);
    setTransaction_type(tt_type);
    setHold_investor_id_trs(investor_id);
    if (tt_type === "Edit") {
      setAmount_trs(amount);
      setNarration_trs(narration);
      setDate_trs(dayjs(date));
      setTrs_id(trs_id);
    }
  };

  const closeAccountTransact = () => {
    setOpen_modal_trs(false);
    setTransaction_type("");
    setAmount_trs(null);
    setNarration_trs(null);
    setDate_trs(dayjs());
    setHold_investor_id_trs(null);
  };

  const closeModalReceipt = () => {
    setOpen_modal_print(false);
    setHold_row();
  };

  const closeModalTransfer = () => {
    setOpen_modal_transfer(false);
    setBank(null);
    setAmount(null);
    setNarration(null);
    setTransfer_date(dayjs);
  };

  const closeModalSettle = () => {
    setOpen_modal_settle(false);
  };

  const handleTransferFunds = () => {
    setLoading(true);
    const data = new FormData();
    data.append("bank_id", bank);
    data.append("amount", amount);
    data.append("narration", narration);
    data.append("date", transfer_date);
    data.append("society_id", id);

    api
      .post("/investors/society/investments/transfer/banks", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        setBank(null);
        setAmount(null);
        setNarration("");
        setTransfer_date(dayjs);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchData();
        setLoading(false);
      });
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleOneInvestor = (investor_id, photo) => {
    setHold_investors(photo);
    const data = new FormData();
    data.append("investor_id", investor_id);
    data.append("society_id", id);

    api
      .post("/investors/get/investor/one", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setHold_income_investor(response.data);
        setOpen_modal_inves(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const deleteTransaction = (id, investor_id) => {
    api
      .delete(`/investors/transaction/investor/account/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleOneInvestor(investor_id, hold_investor);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchData();
      });
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const fetchData = () => {
    api
      .get("/investors/get/investors", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setInvestors(response.data?.investors);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/investors/society/investments/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setSociety_data(response?.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/account/society/all/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setBanks_accounts(response.data?.Accounts);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/commodity/type/commodities/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCommodities(response.data?.Commodities);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get(`/dashboards/details/for/society/dash/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setWarehouses(response.data?.warehouses);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const closeModal = () => {
    setOpen_modal(false);
    setOpen_modal_inves(false);
    formik.handleReset();
    setPayback(0);
    setPayback_interest(0);
  };

  const style_print = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "95vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
      height: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxHeight: "80vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const style_investment_details = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "85%",
    maxHeight: "80vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const style_inves = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95%",
    maxHeight: "95vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
      height: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const formik = useFormik({
    initialValues: {
      investor_name: "",
      company: "",
      type: "",
      society_id: id,
      email: "",
      phone: "",
      photo: null,
    },
    validationSchema: Yup.object({
      type: Yup.string().required("Is investor related to only this society?"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("investor_name", values.investor_name);
      data.append("company_name", values.company);
      data.append("type", values.type);
      data.append("society_id", values.society_id);
      data.append("email", values.email);
      data.append("phone", values.phone);
      data.append("photo", values.photo);

      api
        .post("/investors/create/investor", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoading(false);
          fetchData();
        });
    },
  });

  const handleButtonClickAct = () => {
    document.getElementById("doc").click();
  };

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      setFileName(file.name);
      setImage(URL.createObjectURL(file));
      formik.setFieldValue("photo", file);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const type_setting = (the_type) => {
    setInves_type(the_type);
    formik_inves.setFieldValue("investment_type", the_type);
  };

  const formik_inves = useFormik({
    initialValues: {
      investment_type: "",
      investment_amount: null,
      investment_period: null,
      interest_type: "",
      interest: null,
      terms_and_conditions: "",
      commodity_id: null,
      date: dayjs(),
    },
    validationSchema: Yup.object({
      investment_type: Yup.string().required("Field is empty"),
      investment_amount: Yup.number().required("Field is empty"),
      investment_period: Yup.number().required("Field is empty"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("investment_amount", values.investment_amount);
      data.append("investment_id", edit !== 0 ? edit : 0);
      data.append("society_id", id);
      data.append("investor_id", hold_income_investor?.personal_details?.id);
      data.append("investment_period", values.investment_period);
      data.append("interest", values.interest ? values.interest : 0);
      data.append("interest_type", values.interest_type);
      data.append("investment_type", values.investment_type);
      data.append("terms_and_conditions", values.terms_and_conditions);
      data.append("date", values.date);
      data.append(
        "commodity_id",
        values.commodity_id ? values.commodity_id : 0
      );

      api
        .post("/investors/save/investment", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          handleOneInvestor(
            hold_income_investor?.personal_details?.id,
            hold_investor
          );
          formik_inves.handleReset();
          // setCloseAccord(true);
          setExpanded(false);
          setEdit(0);
          setPre_finance_process([]);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoading(false);
          fetchData();
        });
    },
  });

  const handleViewPayback = (num) => {
    if (num === 1) {
      if (!formik_inves.values.investment_amount) {
        toast.warning("Investment amount is empty");
      } else if (!formik_inves.values.investment_period) {
        toast.warning("Investment period is empty");
      } else if (!formik_inves.values.interest) {
        toast.warning("Interest is empty");
      } else if (!formik_inves.values.interest_type) {
        toast.warning("Interest type is empty");
      } else {
        setLoading(true);
        const data = new FormData();
        data.append("investment_amount", formik_inves.values.investment_amount);
        data.append("investment_period", formik_inves.values.investment_period);
        data.append("interest", formik_inves.values.interest);
        data.append("interest_type", formik_inves.values.interest_type);

        api
          .post("/investors/get/view/pay/check", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            setPayback(response.data?.payback);
            setPayback_interest(response.data?.interest);
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            setLoading(false);
            fetchData();
          });
      }
    } else {
      if (!formik_inves.values.investment_amount) {
        toast.warning("Investment amount is empty");
      } else if (!formik_inves.values.commodity_id) {
        toast.warning("Commodity is empty");
      } else {
        setLoading(true);
        const data = new FormData();
        data.append("investment_amount", formik_inves.values.investment_amount);
        data.append("commodity_id", formik_inves.values.commodity_id);

        api
          .post("/investors/get/view/pay/check/pre_finance", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            setPre_finance_process(response.data);
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            setLoading(false);
            fetchData();
          });
      }
    }
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const printRef = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("Investment.pdf");
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", m: 1 }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Society Investments</b>
            </Typography>
          </Grid>
          {society_data ? (
            <>
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Ittem>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Typography
                            variant="subtitle"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Invested Cash</b>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Typography
                            variant="h3"
                            sx={{ color: "red" }}
                            textAlign="center"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {currencyFormat.format(
                                society_data?.society_funds
                              )}
                            </b>
                          </Typography>
                          {/* <Chip 
                      size='small'
                      label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Transfer funds</b></Typography>}
                      sx={{
                          borderRadius:2,
                          m: 'auto',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                          backgroundColor: 'orange',
                          color:'#000',
                          '&:hover': {
                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                              backgroundColor:'#14213d',
                              color:'#fff'
                          },
                      }} 
                      onClick={transferFunds}
                    /> */}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              Working Investments:{" "}
                              {currencyFormat.format(
                                society_data?.current_invest
                              )}
                            </b>
                          </Typography>
                          <Divider variant="middle" sx={{ m: 1 }} />
                          <Box sx={{ display: "flex", flexDirection: "row" }}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Expected Returns:{" "}
                                {currencyFormat.format(
                                  society_data?.expectation
                                )}
                              </b>
                            </Typography>
                            <Chip
                              size="small"
                              label={
                                <Typography
                                  variant="subtitle"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Settle Returns</b>
                                </Typography>
                              }
                              sx={{
                                borderRadius: 2,
                                ml: 1,
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "green",
                                color: "#fff",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                  color: "#fff",
                                },
                              }}
                              onClick={settleFunds}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Ittem>
                  </Grid>

                  <Grid item xs={12} md={8}>
                    <Ittemm>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Chip
                            size="small"
                            label={
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Add Investor</b>
                              </Typography>
                            }
                            sx={{
                              borderRadius: 2,
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#2b2d42",
                              color: "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#fff",
                              },
                            }}
                            onClick={() => setOpen_modal(true)}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={12}
                          sx={{
                            display: "flex",
                            padding: "10px",
                            maxWidth: "250px",
                            overflowX: "auto",
                            "&::-webkit-scrollbar": {
                              height: "5px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#f1f1f1",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#888",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#555",
                            },
                          }}
                        >
                          {investors[0] ? (
                            investors?.map((item) => (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  margin: 3,
                                  padding: 7,
                                  backgroundColor: "#e9ecef",
                                  borderRadius: 7,
                                }}
                              >
                                <Avatar
                                  sx={{ width: 70, height: 70 }}
                                  src={pic(item.photo)}
                                  alt={
                                    item?.investor_name
                                      ? item?.investor_name
                                      : "O"
                                  }
                                />
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{item.investor_name}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{item.phone}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{item.company}</b>
                                </Typography>
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Open</b>
                                    </Typography>
                                  }
                                  sx={{
                                    borderRadius: 2,
                                    m: 0,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor: "green",
                                    color: "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() =>
                                    handleOneInvestor(
                                      item.investor_id,
                                      item.photo
                                    )
                                  }
                                />
                              </div>
                            ))
                          ) : (
                            <Typography
                              textAlign="center"
                              variant="h4"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>No Registered Investors</b>
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </Ittemm>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} sx={{ mb: 15 }}>
                <Itteemm>
                  <Box>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        variant="fullWidth"
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          label={
                            <b
                              style={{
                                color: "darkblue",
                                fontStyle: "normal",
                                fontFamily:
                                  "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                              }}
                            >
                              Investments
                            </b>
                          }
                          {...a11yProps(0)}
                        />
                        <Tab
                          label={
                            <b
                              style={{
                                color: "darkblue",
                                fontStyle: "normal",
                                fontFamily:
                                  "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                              }}
                            >
                              Repayments
                            </b>
                          }
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </Box>
                    <Typography
                      sx={{ m: 1 }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h4"
                      textAlign="center"
                    >
                      <b>Records</b>
                    </Typography>
                    <CustomTabPanel value={value} index={0}>
                      <Box
                        sx={{
                          m: 1,
                          overflow: "auto",
                          maxWidth: 1250,
                          maxHeight: 600,
                          "&::-webkit-scrollbar": {
                            height: "7px",
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        <Table size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Details</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Photo</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Date (start)</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Investor name</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Company</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Investment Type</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Amount Invested</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Interest type</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Interest</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Investment returns</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Period (months)</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Date (repayment)</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Status</b>
                                </Typography>{" "}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {society_data?.all_investments?.map((row) => (
                              <TableRow
                                key={row.investment_id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                  backgroundColor: "#f5f3f4",
                                }}
                              >
                                <TableCell align="left">
                                  <IconButton
                                    onClick={() => viewInvestment(row, "all")}
                                  >
                                    <FileOpenIcon />
                                  </IconButton>
                                </TableCell>
                                <TableCell align="left">
                                  <Avatar
                                    sx={{ width: 50, height: 50 }}
                                    alt={row.investor_name}
                                    src={pic(row.photo)}
                                  />
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {formatDateToYearMonthDay(
                                        new Date(row.date)
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.investor_name}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.company}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.description}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {currencyFormat.format(
                                        row.amount_investing
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.interest_type}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {row.interest_type === "Percentage Rate"
                                        ? `${row.interest}%`
                                        : currencyFormat.format(row.interest)}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {currencyFormat.format(
                                        row.expected_income
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.period}months</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>N/A</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.status}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Chip
                                      size="small"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>View</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        m: "5px",
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "green",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={() => printReceipt(row)}
                                    />
                                    <Chip
                                      size="small"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Open</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        m: "5px",
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "green",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={() =>
                                        handleOneInvestor(
                                          row.investor_id,
                                          row.photo
                                        )
                                      }
                                    />
                                    <Tooltip
                                      title={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            NB: This feature will check if the
                                            amount invested still exist in
                                            society account before deleting. It
                                            will ignore if society account does
                                            not have sufficient balance to be
                                            deducted.
                                          </b>
                                        </Typography>
                                      }
                                    >
                                      <Chip
                                        size="small"
                                        label={
                                          <Typography
                                            variant="subtitle"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>Delete</b>
                                          </Typography>
                                        }
                                        sx={{
                                          borderRadius: 2,
                                          m: "5px",
                                          boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                          backgroundColor: "red",
                                          color: "#fff",
                                          "&:hover": {
                                            boxShadow:
                                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                          },
                                        }}
                                        onClick={() =>
                                          deleteInvestment(
                                            row.investment_id,
                                            row.investor_id
                                          )
                                        }
                                      />
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <Box
                        sx={{
                          m: 1,
                          overflowX: "auto",
                          maxWidth: 1500,
                          maxHeight: 600,
                          "&::-webkit-scrollbar": {
                            height: "7px",
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        <Table size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Date</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Investor</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Company</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Amount Paid</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Paid from</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Investment type</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Initialized date</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Investment period</b>
                                </Typography>{" "}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {society_data?.repayments?.map((row) => (
                              <TableRow
                                key={row.transaction_id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                  backgroundColor: "#f5f3f4",
                                }}
                              >
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {formatDateToYearMonthDay(
                                        new Date(row.transaction_date)
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.investor_name}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.company}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {currencyFormat.format(
                                        row.expected_income
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.account_name}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.description}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {formatDateToYearMonthDay(
                                        new Date(row.date)
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.months_period}months</b>
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </CustomTabPanel>
                  </Box>
                </Itteemm>
              </Grid>
            </>
          ) : (
            <Box sx={{ m: "auto" }}>
              <CircularProgress sx={{ m: "auto" }} size={25} />
            </Box>
          )}
        </Grid>

        {/* Account Transaction */}
        <Modal
          open={open_modal_trs}
          onClose={closeAccountTransact}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="h4"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>
                    {transaction_type}{" "}
                    {transaction_type === "Edit" ? "Transaction" : "Funds"}
                  </b>
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <DateTimePicker
                  name="date_trs"
                  value={date_trs}
                  onChange={(date) => setDate_trs(date)}
                  // orientation="landscape"
                  slotProps={{
                    textField: {
                      helperText: (
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>DateTime Of {transaction_type}</b>
                        </Typography>
                      ),
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  helperText={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Amount</b>
                    </Typography>
                  }
                  size="small"
                  fullWidth
                  name="amount_trs"
                  value={amount_trs}
                  onChange={(e) => setAmount_trs(e.target.value)}
                  type="number"
                  inputProps={{ step: "any" }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  helperText={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Narration (optional)</b>
                    </Typography>
                  }
                  size="small"
                  fullWidth
                  name="narration_trs"
                  value={narration_trs}
                  onChange={(e) => setNarration_trs(e.target.value)}
                  multiline
                  rows={4}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Chip
                  size="small"
                  label={
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Cancel</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    mr: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "red",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                      color: "#000",
                    },
                  }}
                  onClick={closeAccountTransact}
                />
                <Chip
                  size="small"
                  disabled={loading || !amount_trs || !date_trs}
                  label={
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Confirm</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    mr: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "green",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                      color: "#fff",
                    },
                  }}
                  onClick={handleAccountTransactions}
                />
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={open_re}
          onClose={handleClose_re}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="h4"
                  textAlign="center"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>
                    Amount left to be repaid:{" "}
                    {currencyFormat.format(
                      investment_detaila?.investment_details?.amount_left
                    )}
                  </b>
                </Typography>
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  helperText={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Amount</b>
                    </Typography>
                  }
                  size="small"
                  fullWidth
                  name="amount_re"
                  value={amount_re}
                  onChange={(e) => setAmount_re(e.target.value)}
                  type="number"
                  inputProps={{ step: "any" }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Chip
                  size="medium"
                  label={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Max</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    m: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: max === true ? "green" : "white",
                    color: "#000",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "green",
                      color: "#fff",
                    },
                  }}
                  onClick={doMax}
                />
              </Grid>
              {amount_re ? (
                <Grid item xs={12} md={12}>
                  <Ittem>
                    <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                      {banks_accounts_re?.map((bank) => (
                        <Chip
                          size="small"
                          disabled={bank.current_balance < amount_re}
                          label={
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {bank.account_name} (
                                {currencyFormat.format(bank.current_balance)})
                              </b>
                            </Typography>
                          }
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            backgroundColor:
                              bank.id === bank_id_re ? "green" : "white",
                            color: "#000",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "green",
                              color: "#fff",
                            },
                          }}
                          onClick={() => setBank_id_re(bank.id)}
                        />
                      ))}
                    </Box>
                  </Ittem>
                </Grid>
              ) : null}

              <Grid item xs={12} md={12}>
                {bank_id_re ? (
                  ledgers_re ? (
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                    >
                      {ledgers_re.map((ledg) => (
                        <>
                          <ListItem
                            alignItems="flex-start"
                            secondaryAction={
                              <IconButton
                                onClick={() => setLedger_id_re(ledg.id)}
                                edge="end"
                                aria-label="comments"
                              >
                                <CheckCircle
                                  color={
                                    ledg.id === ledger_id_re
                                      ? "success"
                                      : "primary"
                                  }
                                />
                              </IconButton>
                            }
                          >
                            <ListItemText
                              primary={ledg.account_name}
                              secondary={
                                <Box sx={{ display: "block" }}>
                                  <div>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.primary"
                                    >
                                      <b>{ledg.description}</b>
                                    </Typography>
                                  </div>
                                </Box>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </>
                      ))}
                    </List>
                  ) : (
                    <Typography
                      textAlign="center"
                      sx={{ m: 3 }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>No ledgers available</b>
                    </Typography>
                  )
                ) : null}
              </Grid>
              <Grid item xs={12} md={12}>
                <Box>
                  <Chip
                    size="small"
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cancel</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      ml: "auto",
                      mr: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "red",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "green",
                        color: "#000",
                      },
                    }}
                    onClick={handleClose_re}
                  />
                  <Chip
                    size="small"
                    disabled={!bank_id_re || !ledger_id_re || loading}
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Complete</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      ml: "auto",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "green",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "white",
                        color: "#000",
                      },
                    }}
                    onClick={handleInvestmentRepayment}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        {/* Print modal */}
        <Modal
          open={open_modal_print}
          onClose={closeModalReceipt}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style_print}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Chip
                    size="medium"
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Print</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      mr: "auto",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "orange",
                      color: "#000",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#fff",
                      },
                    }}
                    onClick={handlePrint}
                  />
                  <Chip
                    size="medium"
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Close</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      ml: "auto",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "red",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#fff",
                      },
                    }}
                    onClick={closeModalReceipt}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid container spacing={2} ref={printRef}>
                  <Grid item xs={12} md={12}>
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      textAlign="center"
                      sx={{ color: "grey", mb: 3, ml: "43%" }}
                    >
                      <b>~ The Cooperative ~</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Avatar
                      src={KPeeLogo}
                      alt="KPee logo"
                      sx={{ width: 120, height: 120, m: "auto" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography
                      variant="h3"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      sx={{ textAlign: "center" }}
                    >
                      <b>{hold_row?.society_name}</b>
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography
                      sx={{ textAlign: "center", textDecoration: "underline" }}
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Investor</b>
                    </Typography>

                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Name: {hold_row?.investor_name}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Company: {hold_row?.company}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Investment date: {hold_row?.date}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Email: {hold_row?.email}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography
                      sx={{ textAlign: "center", textDecoration: "underline" }}
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Investment</b>
                    </Typography>

                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Investment Type: {hold_row?.description}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>
                        Amount Invested:{" "}
                        {currencyFormat.format(hold_row?.amount_investing)}
                      </b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>
                        Investment returns:{" "}
                        {currencyFormat.format(hold_row?.expected_income)}
                      </b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Interest Type: {hold_row?.interest_type}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    {hold_row?.interest_type === "Percentage Rate" ? (
                      <>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Interest: {hold_row?.interest}% per month</b>
                        </Typography>
                        {/* <Divider variant="middle" /> */}
                      </>
                    ) : (
                      <>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>
                            Interest:{" "}
                            {currencyFormat.format(hold_row?.interest)}
                          </b>
                        </Typography>
                        {/* <Divider variant="middle" /> */}
                      </>
                    )}

                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Period: {hold_row?.period} months</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Investment Status: {hold_row?.status}</b>
                    </Typography>
                    {/* <Divider variant="middle" /> */}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography
                      sx={{ textAlign: "center", textDecoration: "underline" }}
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Terms and conditions</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>{hold_row?.terms ? hold_row?.terms : ""}</b>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        {/* Repayment modal */}
        <Modal
          open={open_modal_settle}
          onClose={closeModalSettle}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style_inves}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Chip
                  size="medium"
                  label={
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Close</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    ml: "95%",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "red",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                      color: "#fff",
                    },
                  }}
                  onClick={closeModalSettle}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography
                  textAlign="center"
                  variant="h4"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Society Loan Repayments</b>
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Ittem>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Outstanding amount to be repaid</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Typography
                        variant="h4"
                        textAlign="center"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>
                          {currencyFormat.format(society_data?.expectation)}
                        </b>
                      </Typography>
                    </Grid>
                  </Grid>
                </Ittem>
              </Grid>

              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  {society_data?.working_investments?.map((item) => (
                    <Grid item xs={12} md={3}>
                      <IttemCard>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Avatar
                              alt={item.investor_name}
                              src={pic(item.photo)}
                              sx={{ width: 80, height: 80, m: "auto" }}
                            />
                            <Typography
                              textAlign="center"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{item.investor_name}</b>
                            </Typography>
                            <Typography
                              textAlign="center"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{item.company}</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Amount Invested:{" "}
                                {currencyFormat.format(item.amount_investing)}
                              </b>
                            </Typography>
                            <Divider variant="middle" sx={{ m: "1px" }} />
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Investment Returns:{" "}
                                {currencyFormat.format(item.expected_income)}
                              </b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Investment type: {item.description}</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Start date:{" "}
                                {formatDateToYearMonthDay(new Date(item.date))}
                              </b>
                            </Typography>
                            <Divider variant="middle" sx={{ m: "1px" }} />
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Period: {item.period}months</b>
                            </Typography>
                            <Divider variant="middle" sx={{ m: "1px" }} />
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Time left: {item.time_left}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Ending on:{" "}
                                {formatDateToYearMonthDay(
                                  new Date(item.end_date)
                                )}
                              </b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <Payment item={item} fetchData={fetchData} />
                          </Grid>
                        </Grid>
                      </IttemCard>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        {/* Transfer Funds */}
        <Modal
          open={open_modal_transfer}
          onClose={closeModalTransfer}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography
                  textAlign="center"
                  variant="h4"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Transfer Investments to bank accounts</b>
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography
                  textAlign="center"
                  variant="h5"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{currencyFormat.format(society_data?.society_funds)}</b>
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <DateTimePicker
                  name="date"
                  value={transfer_date}
                  onChange={(date) => setTransfer_date(date)}
                  // orientation="landscape"
                  slotProps={{
                    textField: {
                      helperText: (
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>DateTime of transfer</b>
                        </Typography>
                      ),
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={banks_accounts}
                  fullWidth
                  getOptionLabel={(option) => option.account_name}
                  // getOptionDisabled={(option) =>
                  //   option.current_balance < society_data?.society_funds
                  // }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(event, value) => {
                    setBank(value.id);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      helperText={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Select Account</b>
                        </Typography>
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  helperText={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Amount</b>
                    </Typography>
                  }
                  size="small"
                  fullWidth
                  name="amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  type="number"
                  inputProps={{ step: "any" }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  helperText={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Narration (optional)</b>
                    </Typography>
                  }
                  size="small"
                  fullWidth
                  name="narration"
                  value={narration}
                  onChange={(e) => setNarration(e.target.value)}
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Chip
                  size="small"
                  label={
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Close</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    mr: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "red",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                      color: "#000",
                    },
                  }}
                  onClick={closeModalTransfer}
                />
                <Chip
                  size="small"
                  disabled={loading || !bank || !amount}
                  label={
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Transfer</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    mr: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "green",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                      color: "#fff",
                    },
                  }}
                  onClick={handleTransferFunds}
                />
              </Grid>
            </Grid>
          </Box>
        </Modal>

        {/* One Investor */}
        <Modal
          open={open_modal_inves}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style_inves}>
            {hold_income_investor.personal_details ? (
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Chip
                    size="small"
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Close</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      ml: "92%",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "red",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#fff",
                      },
                    }}
                    onClick={closeModal}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography
                    textAlign="center"
                    variant="h3"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Investor's Profile</b>
                  </Typography>
                </Grid>

                <Grid item xs={12} md={3}>
                  <Box sx={{ m: "auto" }}>
                    <Avatar
                      sx={{ height: 170, width: 170, m: "auto" }}
                      alt={"I"}
                      src={pic(hold_investor)}
                    />
                  </Box>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>
                      Name:{" "}
                      {hold_income_investor?.personal_details?.investor_name}
                    </b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>
                      Company: {hold_income_investor?.personal_details?.company}
                    </b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Type: {hold_income_investor?.personal_details?.type}</b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>
                      email: {hold_income_investor?.personal_details?.email}
                    </b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>
                      Contact Phone:{" "}
                      {hold_income_investor?.personal_details?.phone}
                    </b>
                  </Typography>
                  <Divider variant="middle" />
                  <Chip
                    size="small"
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Edit Profile</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "orange",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#fff",
                      },
                    }}
                    // onClick={}
                  />
                </Grid>

                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <Typography
                          textAlign="center"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Account balance</b>
                        </Typography>
                      </Box>
                      <Ittem>
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Chip
                            size="small"
                            label={
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Deposit funds</b>
                              </Typography>
                            }
                            sx={{
                              borderRadius: 2,
                              m: "auto",
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#14213d",
                              color: "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#fff",
                              },
                            }}
                            onClick={() =>
                              accountTransact(
                                "Deposit",
                                hold_income_investor?.personal_details?.id,
                                null,
                                "",
                                "",
                                0
                              )
                            }
                          />
                          <Chip
                            size="small"
                            label={
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Withdraw funds</b>
                              </Typography>
                            }
                            sx={{
                              borderRadius: 2,
                              m: "auto",
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "red",
                              color: "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#fff",
                              },
                            }}
                            onClick={() =>
                              accountTransact(
                                "Withdraw",
                                hold_income_investor?.personal_details?.id,
                                null,
                                "",
                                "",
                                0
                              )
                            }
                          />
                        </Box>
                        <Box sx={{ m: 2 }}>
                          <Typography
                            textAlign="center"
                            variant="h2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {currencyFormat.format(
                                hold_income_investor?.personal_details
                                  .current_balance
                                  ? hold_income_investor?.personal_details
                                      .current_balance
                                  : 0
                              )}
                            </b>
                          </Typography>
                        </Box>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Box>
                        <Typography
                          textAlign="center"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Investment balance</b>
                        </Typography>
                      </Box>
                      <Ittem>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Current investment:</b>{" "}
                          <b style={{ fontSize: "30px" }}>
                            {hold_income_investor?.current_investment
                              ? currencyFormat.format(
                                  hold_income_investor?.current_investment
                                )
                              : currencyFormat.format(0)}
                          </b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Current Expectation:</b>{" "}
                          <b style={{ fontSize: "30px", color: "red" }}>
                            {hold_income_investor?.current_expectation
                              ? currencyFormat.format(
                                  hold_income_investor?.current_expectation
                                )
                              : currencyFormat.format(0)}
                          </b>
                        </Typography>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Accordion
                        sx={{ borderRadius: 10, mb: 2 }}
                        expanded={expanded}
                        onClose={handleChangeExpand}
                      >
                        <AccordionSummary
                          expandIcon={
                            <IconButton
                              onClick={() => setExpanded((prev) => !prev)}
                            >
                              <ExpandMore />
                            </IconButton>
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          display="flex"
                        >
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {edit !== 0
                                ? "Edit Investment (NB!! editing cannot affect the society account balance)"
                                : "New Investment"}
                            </b>
                          </Typography>
                          {edit !== 0 ? (
                            <Chip
                              size="small"
                              label={
                                <Typography
                                  variant="subtitle"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Stop Editing</b>
                                </Typography>
                              }
                              sx={{
                                borderRadius: 2,
                                ml: "auto",
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "red",
                                color: "#fff",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                  color: "#fff",
                                },
                              }}
                              onClick={handleChangeExpand}
                            />
                          ) : null}
                        </AccordionSummary>
                        <Divider variant="middle" />
                        <AccordionDetails>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Chip
                                  size="medium"
                                  label={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Equity Shares</b>
                                    </Typography>
                                  }
                                  variant={
                                    inves_type === "Equity Shares"
                                      ? "outlined"
                                      : "filled"
                                  }
                                  sx={{
                                    borderRadius: 3,
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                      inves_type === "Equity Shares"
                                        ? "#2b2d42"
                                        : "#fff",
                                    color:
                                      inves_type === "Equity Shares"
                                        ? "#fff"
                                        : "#000",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#fff",
                                    },
                                  }}
                                  onClick={() => type_setting("Equity Shares")}
                                />
                                <Chip
                                  size="medium"
                                  label={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Pre Finance</b>
                                    </Typography>
                                  }
                                  variant={
                                    inves_type === "Pre Finance"
                                      ? "outlined"
                                      : "filled"
                                  }
                                  sx={{
                                    borderRadius: 3,
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                      inves_type === "Pre Finance"
                                        ? "#2b2d42"
                                        : "#fff",
                                    color:
                                      inves_type === "Pre Finance"
                                        ? "#fff"
                                        : "#000",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#fff",
                                    },
                                  }}
                                  onClick={() => type_setting("Pre Finance")}
                                />
                                <Chip
                                  size="medium"
                                  label={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Capital Finance</b>
                                    </Typography>
                                  }
                                  variant={
                                    inves_type === "Capital Finance"
                                      ? "outlined"
                                      : "filled"
                                  }
                                  sx={{
                                    borderRadius: 3,
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                      inves_type === "Capital Finance"
                                        ? "#2b2d42"
                                        : "#fff",
                                    color:
                                      inves_type === "Capital Finance"
                                        ? "#fff"
                                        : "#000",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#fff",
                                    },
                                  }}
                                  onClick={() =>
                                    type_setting("Capital Finance")
                                  }
                                />
                              </Box>
                            </Grid>
                            {inves_type === "Equity Shares" ||
                            inves_type === "Capital Finance" ? (
                              <>
                                <Grid item xs={12} md={12}>
                                  <Typography
                                    variant="h6"
                                    sx={{ display: "flex" }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    {loading ? (
                                      <CircularProgress size={25} />
                                    ) : (
                                      <Chip
                                        size="small"
                                        label={
                                          <Typography
                                            variant="subtitle"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>View Returns</b>
                                          </Typography>
                                        }
                                        sx={{
                                          borderRadius: 2,
                                          mr: 1,
                                          boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                          backgroundColor: "orange",
                                          color: "#000",
                                          "&:hover": {
                                            boxShadow:
                                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                            color: "#000",
                                          },
                                        }}
                                        onClick={() => handleViewPayback(1)}
                                      />
                                    )}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <b>
                                        Interest Amount:{" "}
                                        {currencyFormat.format(
                                          payback_interest
                                        )}
                                      </b>
                                      <b>
                                        Total Investment Returns:{" "}
                                        {currencyFormat.format(payback)}
                                      </b>
                                    </div>
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify date contract was signed. This
                                        will be used as beginning of the period.
                                      </Typography>
                                    }
                                  >
                                    <DesktopDatePicker
                                      name="date"
                                      value={formik_inves.values.date}
                                      onChange={(date) =>
                                        formik_inves.setFieldValue("date", date)
                                      }
                                      // orientation="landscape"
                                      slotProps={{
                                        textField: {
                                          helperText: (
                                            <Tooltip
                                              title={
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  Specify date contract was
                                                  signed. This will be used as
                                                  beginning of the period.
                                                </Typography>
                                              }
                                            >
                                              <b>Select date</b>
                                            </Tooltip>
                                          ),
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                <Tooltip title={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  Specify Investment type in a short description, Special shares or early payment of crops etc...
                                </Typography>}>
                                  <TextField 
                                    helperText={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Investment type</Typography>}
                                    size='small'
                                    fullWidth
                                    multiline
                                    rows={2}
                                    name='investment_type'
                                    value={formik_inves.values.investment_type}
                                    onChange={formik_inves.handleChange}
                                    onBlur={formik_inves.handleBlur}
                                    error={formik_inves.touched.investment_type && Boolean(formik_inves.errors.investment_type)}
                                  />
                                </Tooltip>
                              </Grid> */}

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify investment period in months,eg
                                        12(1 year), 24(2 years), etc...
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Period</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      name="investment_period"
                                      value={
                                        formik_inves.values.investment_period
                                      }
                                      onChange={formik_inves.handleChange}
                                      onBlur={formik_inves.handleBlur}
                                      error={
                                        formik_inves.touched
                                          .investment_period &&
                                        Boolean(
                                          formik_inves.errors.investment_period
                                        )
                                      }
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Choose interest type, for fixed amount
                                        or percentage rate.
                                      </Typography>
                                    }
                                  >
                                    <Autocomplete
                                      disablePortal
                                      id="combo-box-demo"
                                      options={[
                                        { id: 1, type: "Fixed Amount" },
                                        { id: 2, type: "Percentage Rate" },
                                      ]}
                                      fullWidth
                                      getOptionLabel={(option) => option.type}
                                      isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                      }
                                      onChange={(event, value) => {
                                        formik_inves.setFieldValue(
                                          "interest_type",
                                          value.type
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          size="small"
                                          helperText={
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                              <b>Interest type</b>
                                            </Typography>
                                          }
                                          error={
                                            formik_inves.touched
                                              .interest_type &&
                                            Boolean(
                                              formik_inves.errors.interest_type
                                            )
                                          }
                                          onBlur={formik_inves.handleBlur}
                                        />
                                      )}
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify interest on investment. If you
                                        choose fixed amount in the prev.
                                        textfield, then enter the amount,
                                        otherwise enter the percentage rate for
                                        your specified period
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Interest</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      value={formik_inves.values.interest}
                                      name="interest"
                                      type="number"
                                      inputProps={{ step: "any" }}
                                      onChange={formik_inves.handleChange}
                                      onBlur={formik_inves.handleBlur}
                                      error={
                                        formik_inves.touched.interest &&
                                        Boolean(formik_inves.errors.interest)
                                      }
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify amount investing.
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Amount</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      value={
                                        formik_inves.values.investment_amount
                                      }
                                      name="investment_amount"
                                      onChange={formik_inves.handleChange}
                                      onBlur={formik_inves.handleBlur}
                                      error={
                                        formik_inves.touched
                                          .investment_amount &&
                                        Boolean(
                                          formik_inves.errors.investment_amount
                                        )
                                      }
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify terms and conditions, this is an
                                        optional field, Specify terms if there
                                        are any agreed upon with investor.
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Terms and Conditions (Optional)</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      multiline
                                      onChange={formik_inves.handleChange}
                                      value={
                                        formik_inves.values.terms_and_conditions
                                      }
                                      name="terms_and_conditions"
                                      rows={4}
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Clear Form</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      mr: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "red",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={formik_inves.handleReset}
                                  />
                                  <Chip
                                    size="small"
                                    disabled={loading}
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Confirm</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      mr: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={formik_inves.handleSubmit}
                                  />
                                </Grid>
                              </>
                            ) : inves_type === "Pre Finance" ? (
                              <>
                                <Grid item xs={12} md={12}>
                                  {loading ? (
                                    <CircularProgress size={25} />
                                  ) : (
                                    <Chip
                                      size="small"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Summarize</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        mr: 1,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "orange",
                                        color: "#000",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={() => handleViewPayback(2)}
                                    />
                                  )}
                                  {pre_finance_process[0] ? (
                                    <Typography
                                      sx={{ textAlign: "center" }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Current Prices</b>
                                    </Typography>
                                  ) : null}

                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      m: "auto",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {pre_finance_process?.map((item) => (
                                      <div
                                        style={{
                                          display: "flex",
                                          boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                          flexDirection: "column",
                                          margin: 5,
                                          padding: 7,
                                          backgroundColor: "#fff",
                                          borderRadius: 15,
                                        }}
                                      >
                                        <Typography
                                          sx={{ textAlign: "center" }}
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>{item.Grade}</b>
                                        </Typography>
                                        <Typography
                                          sx={{ textAlign: "center" }}
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>
                                            {currencyFormat.format(
                                              item.current_price
                                            )}
                                            /bag
                                          </b>
                                        </Typography>
                                        <Divider variant="middle" />
                                        {item.bags?.map((bag) => (
                                          <>
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                              <b>
                                                {bag.unit}kg:{" "}
                                                {bag.number_of_bags}bags
                                              </b>
                                            </Typography>
                                            <Divider variant="middle" />
                                          </>
                                        ))}
                                      </div>
                                    ))}
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify date contract was signed. This
                                        will be used as beginning of the period.
                                      </Typography>
                                    }
                                  >
                                    <DesktopDatePicker
                                      name="date"
                                      value={formik_inves.values.date}
                                      onChange={(date) =>
                                        formik_inves.setFieldValue("date", date)
                                      }
                                      // orientation="landscape"
                                      slotProps={{
                                        textField: {
                                          helperText: (
                                            <Tooltip
                                              title={
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  Specify date contract was
                                                  signed. This will be used as
                                                  beginning of the period.
                                                </Typography>
                                              }
                                            >
                                              <b>Select date</b>
                                            </Tooltip>
                                          ),
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify investment period in months,eg
                                        12(1 year), 24(2 years), etc...
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Period</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      name="investment_period"
                                      value={
                                        formik_inves.values.investment_period
                                      }
                                      onChange={formik_inves.handleChange}
                                      onBlur={formik_inves.handleBlur}
                                      error={
                                        formik_inves.touched
                                          .investment_period &&
                                        Boolean(
                                          formik_inves.errors.investment_period
                                        )
                                      }
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Choose crop.
                                      </Typography>
                                    }
                                  >
                                    <Autocomplete
                                      disablePortal
                                      id="combo-box-demo"
                                      options={commodities}
                                      fullWidth
                                      getOptionLabel={(option) =>
                                        option.commodity
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                      }
                                      onChange={(event, value) => {
                                        formik_inves.setFieldValue(
                                          "commodity_id",
                                          value.id
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          size="small"
                                          helperText={
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                              <b>Crops (Society's)</b>
                                            </Typography>
                                          }
                                        />
                                      )}
                                    />
                                  </Tooltip>
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                <Tooltip title={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  Choose warehouse crops would be pick from.
                                </Typography>}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={warehouses}
                                    fullWidth
                                    getOptionLabel={(option) => option.warehouse_name}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={(event, value) => {
                                        formik_inves.setFieldValue('warehouse_id', value.id)
                                    }}
                                    renderInput={(params) => 
                                    <TextField 
                                      {...params}
                                      size="small" 
                                      helperText={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Warehouse</b></Typography>}
                                    />
                                    }
                                />
                                </Tooltip>
                              </Grid> */}

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify amount investing.
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Amount</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      value={
                                        formik_inves.values.investment_amount
                                      }
                                      name="investment_amount"
                                      onChange={formik_inves.handleChange}
                                      onBlur={formik_inves.handleBlur}
                                      error={
                                        formik_inves.touched
                                          .investment_amount &&
                                        Boolean(
                                          formik_inves.errors.investment_amount
                                        )
                                      }
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Tooltip
                                    title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Specify terms and conditions, this is an
                                        optional field, Specify terms if there
                                        are any agreed upon with investor.
                                      </Typography>
                                    }
                                  >
                                    <TextField
                                      helperText={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Terms and Conditions (Optional)</b>
                                        </Typography>
                                      }
                                      size="small"
                                      fullWidth
                                      multiline
                                      onChange={formik_inves.handleChange}
                                      value={
                                        formik_inves.values.terms_and_conditions
                                      }
                                      name="terms_and_conditions"
                                      rows={4}
                                    />
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Clear Form</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      mr: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "red",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={formik_inves.handleReset}
                                  />
                                  <Chip
                                    size="small"
                                    disabled={loading}
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Confirm</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      mr: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={formik_inves.handleSubmit}
                                  />
                                </Grid>
                              </>
                            ) : null}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Box>
                        <Tabs
                          variant="fullWidth"
                          value={value1}
                          onChange={handleChange1}
                          aria-label="basic tabs example"
                          sx={{
                            backgroundColor: "#e9ecef",
                            borderRadius: 7,
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            transition:
                              "background-color 0.3s ease, box-shadow 0.3s ease",
                            "&:hover": {
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#f8f9fa",
                            },
                          }}
                        >
                          <Tab
                            label={
                              <b
                                style={{
                                  color: "#2b2d42",
                                  fontFamily:
                                    "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                                }}
                              >
                                Investment Records
                              </b>
                            }
                            {...a11yProps(0)}
                          />
                          <Tab
                            label={
                              <b
                                style={{
                                  color: "#2b2d42",
                                  fontFamily:
                                    "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                                }}
                              >
                                Account Transactions
                              </b>
                            }
                            {...a11yProps(1)}
                          />
                        </Tabs>
                        <CustomTabPanel value={value1} index={0}>
                          <Box
                            sx={{
                              maxWidth: 1000,
                              overflowX: "auto",
                              "&::-webkit-scrollbar": {
                                width: "7px",
                                height: "7px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            <Table size="small" aria-label="a dense table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Details</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Date (start)</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Investment Type</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Amount Invested</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Interest type</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Interest</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Investment returns</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Period (months)</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Date (repayment)</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Status</b>
                                    </Typography>{" "}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {hold_income_investor?.prev_investment?.map(
                                  (row) => (
                                    <TableRow
                                      key={row.id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                      }}
                                    >
                                      <TableCell align="left">
                                        <IconButton
                                          onClick={() =>
                                            viewInvestment(row, "one")
                                          }
                                        >
                                          <FileOpenIcon />
                                        </IconButton>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {formatDateToYearMonthDay(
                                              new Date(row.date)
                                            )}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.description}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {currencyFormat.format(
                                              row.amount_investing
                                            )}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.interest_type}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {row.interest_type ===
                                            "Percentage Rate"
                                              ? `${row.interest}%`
                                              : currencyFormat.format(
                                                  row.interest
                                                )}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {currencyFormat.format(
                                              row.expected_income
                                            )}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.months_period}months</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>N/A</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.status}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <Chip
                                            size="small"
                                            label={
                                              <Typography
                                                variant="subtitle"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                              >
                                                <b>Open</b>
                                              </Typography>
                                            }
                                            sx={{
                                              borderRadius: 2,
                                              m: "5px",
                                              boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                              backgroundColor: "green",
                                              color: "#fff",
                                              "&:hover": {
                                                boxShadow:
                                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                              },
                                            }}
                                            onClick={() => printReceipt(row)}
                                          />
                                          <Chip
                                            size="small"
                                            label={
                                              <Typography
                                                variant="subtitle"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                              >
                                                <b>Edit</b>
                                              </Typography>
                                            }
                                            sx={{
                                              borderRadius: 2,
                                              m: "5px",
                                              boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                              backgroundColor: "green",
                                              color: "#fff",
                                              "&:hover": {
                                                boxShadow:
                                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                              },
                                            }}
                                            onClick={() => handleEdit(row)}
                                          />
                                          <Tooltip
                                            title={
                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>
                                                  NB: This feature will check if
                                                  the amount invested still
                                                  exist in society account
                                                  before deleting. It will
                                                  ignore if society account does
                                                  not have sufficient balance to
                                                  be deducted.
                                                </b>
                                              </Typography>
                                            }
                                          >
                                            <Chip
                                              size="small"
                                              label={
                                                <Typography
                                                  variant="subtitle"
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                >
                                                  <b>Delete</b>
                                                </Typography>
                                              }
                                              sx={{
                                                borderRadius: 2,
                                                m: "5px",
                                                boxShadow:
                                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                backgroundColor: "red",
                                                color: "#fff",
                                                "&:hover": {
                                                  boxShadow:
                                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                  backgroundColor: "#14213d",
                                                },
                                              }}
                                              onClick={() =>
                                                deleteInvestment(
                                                  row.id,
                                                  row.investor_id
                                                )
                                              }
                                            />
                                          </Tooltip>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Box>
                        </CustomTabPanel>
                        <CustomTabPanel value={value1} index={1}>
                          <Box
                            sx={{
                              maxWidth: 1000,
                              overflowX: "auto",
                              "&::-webkit-scrollbar": {
                                width: "7px",
                                height: "7px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            <Table size="small" aria-label="a dense table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Date</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Debit</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Credit</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Balance</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Narration</b>
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Actions</b>
                                    </Typography>{" "}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {hold_income_investor?.account_transactions?.map(
                                  (row) => (
                                    <TableRow
                                      key={row.id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                      }}
                                    >
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {formatDateToYearMonthDayTime(
                                              new Date(row.transaction_date)
                                            )}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {row.transactiontype_id === 2
                                              ? currencyFormat.format(
                                                  row.amount
                                                )
                                              : currencyFormat.format(0)}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {row.transactiontype_id === 1
                                              ? currencyFormat.format(
                                                  row.amount
                                                )
                                              : currencyFormat.format(0)}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {currencyFormat.format(row.balance)}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.narration}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <Chip
                                            size="small"
                                            label={
                                              <Typography
                                                variant="subtitle"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                              >
                                                <b>Edit</b>
                                              </Typography>
                                            }
                                            sx={{
                                              borderRadius: 2,
                                              m: "5px",
                                              boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                              backgroundColor: "orange",
                                              color: "#fff",
                                              "&:hover": {
                                                boxShadow:
                                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                              },
                                            }}
                                            onClick={() =>
                                              accountTransact(
                                                "Edit",
                                                row.investor_id,
                                                row.amount,
                                                row.narration,
                                                row.transaction_date,
                                                row.id
                                              )
                                            }
                                          />
                                          <Tooltip
                                            title={
                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>
                                                  NB: This will not affect
                                                  account balance.
                                                </b>
                                              </Typography>
                                            }
                                          >
                                            <Chip
                                              size="small"
                                              label={
                                                <Typography
                                                  variant="subtitle"
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                >
                                                  <b>Delete</b>
                                                </Typography>
                                              }
                                              sx={{
                                                borderRadius: 2,
                                                m: "5px",
                                                boxShadow:
                                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                backgroundColor: "red",
                                                color: "#fff",
                                                "&:hover": {
                                                  boxShadow:
                                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                  backgroundColor: "#14213d",
                                                },
                                              }}
                                              onClick={() =>
                                                deleteTransaction(
                                                  row.id,
                                                  row.investor_id
                                                )
                                              }
                                            />
                                          </Tooltip>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Box>
                        </CustomTabPanel>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
          </Box>
        </Modal>

        <Modal
          open={open_modal_investment}
          onClose={closeOpenModalInvestment}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style_investment_details}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography
                  sx={{ textAlign: "center" }}
                  variant="h4"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{pre_or_equity} Investment Details</b>
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Date of investment:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {formatDateToYearMonthDay(
                        new Date(investment_detaila?.investment_details?.date)
                      )}
                    </b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography
                    sx={{ mr: "auto" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Investment Status:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {investment_detaila?.investment_details?.status}
                    </b>
                  </Typography>
                  {investment_detaila?.investment_details?.status ===
                  "Working" ? (
                    <>
                      <div className="newtons-cradle">
                        <div className="newtons-cradle__dot"></div>
                        <div className="newtons-cradle__dot"></div>
                        <div className="newtons-cradle__dot"></div>
                        <div className="newtons-cradle__dot"></div>
                      </div>
                    </>
                  ) : null}
                </Box>
                <Box
                  sx={{
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Investment Amount:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {currencyFormat.format(
                        investment_detaila?.investment_details?.amount_investing
                      )}
                    </b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Period:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {investment_detaila?.investment_details?.months_period}{" "}
                      months
                    </b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Crop:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {investment_detaila?.investment_details?.commodity}
                    </b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>end date:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {formatDateToYearMonthDay(
                        new Date(investment_detaila?.end_date)
                      )}
                    </b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Time left:</b>{" "}
                    <b style={{ color: "#260701", fontSize: 15 }}>
                      {investment_detaila?.time_left}
                    </b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "block",
                    p: 2,
                    minHeight: 100,
                    m: 1,
                    borderRadius: 5,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Terms and Conditions:</b>
                  </Typography>
                  <Typography
                    sx={{ color: "#260701", fontSize: 15 }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{investment_detaila?.investment_details?.terms}</b>
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Chip
                    size="medium"
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Make Payment (Cash)</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 5,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "orange",
                      color: "#000",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#fff",
                      },
                    }}
                    onClick={() => {
                      handleOpen_re(
                        investment_detaila?.investment_details?.investor_id,
                        investment_detaila?.investment_details?.id
                      );
                      setKind_cash(false);
                    }}
                  />

                  <Chip
                    size="medium"
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Make Payment In Kind(Bags)</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 5,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "orange",
                      color: "#000",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#fff",
                      },
                    }}
                    onClick={() => setKind_cash(true)}
                  />
                </Box>
                {kind_cash ? (
                  <>
                    <Typography
                      sx={{
                        color: "#260701",
                        textAlign: "center",
                        fontSize: 15,
                      }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>
                        Bag prices on investment date (
                        {formatDateToYearMonthDay(
                          new Date(investment_detaila?.investment_details?.date)
                        )}
                        )
                      </b>
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        m: "auto",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          flexDirection: "column",
                          margin: 5,
                          padding: 7,
                          backgroundColor: "#fff",
                          borderRadius: 15,
                        }}
                      >
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Grade A</b>
                        </Typography>
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>
                            {currencyFormat.format(
                              investment_detaila?.investment_details?.grade_a
                            )}
                            /bag
                          </b>
                        </Typography>
                        <Divider variant="middle" />
                        {investment_detaila?.grade_a?.map((bag) => (
                          <>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {bag.unit}kg: {bag.number_of_bags}bags
                              </b>
                            </Typography>
                            <Divider variant="middle" />
                          </>
                        ))}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          flexDirection: "column",
                          margin: 5,
                          padding: 7,
                          backgroundColor: "#fff",
                          borderRadius: 15,
                        }}
                      >
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Grade B</b>
                        </Typography>
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>
                            {currencyFormat.format(
                              investment_detaila?.investment_details?.grade_b
                            )}
                            /bag
                          </b>
                        </Typography>
                        <Divider variant="middle" />
                        {investment_detaila?.grade_b?.map((bag) => (
                          <>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {bag.unit}kg: {bag.number_of_bags}bags
                              </b>
                            </Typography>
                            <Divider variant="middle" />
                          </>
                        ))}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          flexDirection: "column",
                          margin: 5,
                          padding: 7,
                          backgroundColor: "#fff",
                          borderRadius: 15,
                        }}
                      >
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Grade C</b>
                        </Typography>
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>
                            {currencyFormat.format(
                              investment_detaila?.investment_details?.grade_c
                            )}
                            /bag
                          </b>
                        </Typography>
                        <Divider variant="middle" />
                        {investment_detaila?.grade_c?.map((bag) => (
                          <>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {bag.unit}kg: {bag.number_of_bags}bags
                              </b>
                            </Typography>
                            <Divider variant="middle" />
                          </>
                        ))}
                      </div>
                    </Box>

                    <Typography
                      sx={{
                        color: "#260701",
                        textAlign: "center",
                        fontSize: 15,
                        mt: 2,
                      }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Current bag prices (live)</b>
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        m: "auto",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {investment_detaila?.current_prices?.map((item) => (
                        <div
                          style={{
                            display: "flex",
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            flexDirection: "column",
                            margin: 5,
                            padding: 7,
                            backgroundColor: "#fff",
                            borderRadius: 15,
                          }}
                        >
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {item.Grade === "Grade A" ? (
                                item.current_price >
                                investment_detaila?.investment_details
                                  ?.grade_a ? (
                                  <ArrowUpwardIcon
                                    sx={{ color: "green", mr: 1 }}
                                  />
                                ) : item.current_price <
                                  investment_detaila?.investment_details
                                    ?.grade_a ? (
                                  <ArrowDownwardIcon
                                    sx={{ color: "red", mr: 1 }}
                                  />
                                ) : (
                                  <BalanceIcon sx={{ mr: 1 }} />
                                )
                              ) : item.Grade === "Grade B" ? (
                                item.current_price >
                                investment_detaila?.investment_details
                                  ?.grade_b ? (
                                  <ArrowUpwardIcon
                                    sx={{ color: "green", mr: 1 }}
                                  />
                                ) : item.current_price <
                                  investment_detaila?.investment_details
                                    ?.grade_b ? (
                                  <ArrowDownwardIcon
                                    sx={{ color: "red", mr: 1 }}
                                  />
                                ) : (
                                  <BalanceIcon sx={{ mr: 1 }} />
                                )
                              ) : item.Grade === "Grade C" ? (
                                item.current_price >
                                investment_detaila?.investment_details
                                  ?.grade_c ? (
                                  <ArrowUpwardIcon
                                    sx={{ color: "green", mr: 1 }}
                                  />
                                ) : item.current_price <
                                  investment_detaila?.investment_details
                                    ?.grade_c ? (
                                  <ArrowDownwardIcon
                                    sx={{ color: "red", mr: 1 }}
                                  />
                                ) : (
                                  <BalanceIcon sx={{ mr: 1 }} />
                                )
                              ) : null}
                            </b>
                          </Typography>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>{item.grade}</b>
                          </Typography>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              {currencyFormat.format(item.current_price)}/bag
                            </b>
                          </Typography>
                          <Divider variant="middle" />
                          {item.bags?.map((bag) => (
                            <>
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  {bag.unit}kg: {bag.number_of_bags}bags
                                </b>
                              </Typography>
                              <Divider variant="middle" />
                            </>
                          ))}
                        </div>
                      ))}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Chip
                        size="medium"
                        label={
                          <Typography
                            variant="subtitle"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Get Crops</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 5,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "orange",
                          color: "#000",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#fff",
                          },
                        }}
                        onClick={() => setGet_crops(true)}
                      />
                    </Box>
                    <Box>
                      {get_crops ? (
                        <>
                          <Typography
                            sx={{
                              color: "#260701",
                              textAlign: "center",
                              fontSize: 15,
                              mt: 2,
                            }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Choose Specifications</b>
                          </Typography>
                          <Typography
                            sx={{
                              color: "#260701",
                              textAlign: "center",
                              fontSize: 15,
                              mt: 2,
                            }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Amount left:{" "}
                              {currencyFormat.format(
                                left_amount
                                  ? left_amount
                                  : investment_detaila?.investment_details
                                      ?.amount_investing
                              )}
                            </b>
                          </Typography>

                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                m: "auto",
                              }}
                            >
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                {where === 0 ? (
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        // variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>
                                          {left_amount !== undefined &&
                                          left_amount !== null
                                            ? left_amount
                                            : Math.round(
                                                ((investment_detaila
                                                  ?.investment_details
                                                  ?.amount_investing || 0) /
                                                  (investment_detaila
                                                    ?.investment_details
                                                    ?.grade_a || 1)) *
                                                  100
                                              )}{" "}
                                          bag(s) available
                                        </b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      mr: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() => setWhere((prev) => prev + 1)}
                                  />
                                ) : null}

                                <b style={{ marginRight: 1 }}>
                                  Grade A (100 kg)
                                </b>
                                <IconButton
                                  sx={{ m: 1 }}
                                  onClick={() =>
                                    handleAddBag(
                                      investment_detaila?.investment_details
                                        ?.commodity_id,
                                      "Grade A",
                                      100,
                                      "-"
                                    )
                                  }
                                >
                                  <IndeterminateCheckBoxIcon />
                                </IconButton>
                                <b style={{ m: 1 }}>
                                  <TextField
                                    type="number"
                                    size="small"
                                    sx={{ width: 100 }}
                                    name="grade_a_100"
                                    value={grade_a_100}
                                    onChange={(e) =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade A",
                                        100,
                                        e.target.value
                                      )
                                    }
                                  />
                                </b>
                                <IconButton
                                  sx={{ m: 1 }}
                                  onClick={() =>
                                    handleAddBag(
                                      investment_detaila?.investment_details
                                        ?.commodity_id,
                                      "Grade A",
                                      100,
                                      "+"
                                    )
                                  }
                                >
                                  <AddBoxIcon />
                                </IconButton>
                                {where >= 1 ? (
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Fill and Proccess</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      ml: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() =>
                                      fill_and_proccess(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade A",
                                        100
                                      )
                                    }
                                  />
                                ) : null}
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Next</b>
                                    </Typography>
                                  }
                                  sx={{
                                    borderRadius: 2,
                                    ml: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor: "green",
                                    color: "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#fff",
                                    },
                                  }}
                                  onClick={() => setWhere((prev) => prev + 1)}
                                />
                              </Typography>
                            </Box>

                            {where >= 1 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  m: "auto",
                                }}
                              >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  {where === 1 ? (
                                    <Chip
                                      size="small"
                                      label={
                                        <Typography
                                          // variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>
                                            {investment_detaila
                                              ?.investment_details?.grade_a *
                                              100}{" "}
                                            bag(s) available{" "}
                                          </b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        mr: 1,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "green",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={() =>
                                        setWhere((prev) => prev + 1)
                                      }
                                    />
                                  ) : null}
                                  <b style={{ marginRight: 1 }}>
                                    Grade A (50 kg)
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade A",
                                        50,
                                        "-"
                                      )
                                    }
                                  >
                                    <IndeterminateCheckBoxIcon />
                                  </IconButton>
                                  <b style={{ m: 1 }}>
                                    <TextField
                                      type="number"
                                      size="small"
                                      sx={{ width: 100 }}
                                      name="grade_a_50"
                                      value={grade_a_50}
                                      onChange={(e) =>
                                        handleAddBag(
                                          investment_detaila?.investment_details
                                            ?.commodity_id,
                                          "Grade A",
                                          50,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade A",
                                        50,
                                        "+"
                                      )
                                    }
                                  >
                                    <AddBoxIcon />
                                  </IconButton>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Next</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      ml: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() => setWhere((prev) => prev + 1)}
                                  />
                                </Typography>
                              </Box>
                            ) : null}

                            {where >= 2 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  m: "auto",
                                }}
                              >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b style={{ marginRight: 1 }}>
                                    Grade B (100 kg)
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade B",
                                        100,
                                        "-"
                                      )
                                    }
                                  >
                                    <IndeterminateCheckBoxIcon />
                                  </IconButton>
                                  <b style={{ m: 1 }}>
                                    <TextField
                                      type="number"
                                      size="small"
                                      sx={{ width: 100 }}
                                      name="grade_b_100"
                                      value={grade_b_100}
                                      onChange={(e) =>
                                        handleAddBag(
                                          investment_detaila?.investment_details
                                            ?.commodity_id,
                                          "Grade B",
                                          100,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade B",
                                        100,
                                        "+"
                                      )
                                    }
                                  >
                                    <AddBoxIcon />
                                  </IconButton>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Next</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      ml: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() => setWhere((prev) => prev + 1)}
                                  />
                                </Typography>
                              </Box>
                            ) : null}

                            {where >= 3 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  m: "auto",
                                }}
                              >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b style={{ marginRight: 1 }}>
                                    Grade B (50 kg)
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade B",
                                        50,
                                        "-"
                                      )
                                    }
                                  >
                                    <IndeterminateCheckBoxIcon />
                                  </IconButton>
                                  <b style={{ m: 1 }}>
                                    <TextField
                                      type="number"
                                      size="small"
                                      sx={{ width: 100 }}
                                      name="grade_b_50"
                                      value={grade_b_50}
                                      onChange={(e) =>
                                        handleAddBag(
                                          investment_detaila?.investment_details
                                            ?.commodity_id,
                                          "Grade B",
                                          50,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade B",
                                        50,
                                        "+"
                                      )
                                    }
                                  >
                                    <AddBoxIcon />
                                  </IconButton>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Next</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      ml: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() => setWhere((prev) => prev + 1)}
                                  />
                                </Typography>
                              </Box>
                            ) : null}
                            {where >= 4 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  m: "auto",
                                }}
                              >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b style={{ marginRight: 1 }}>
                                    Grade C (100 kg)
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade C",
                                        100,
                                        "-"
                                      )
                                    }
                                  >
                                    <IndeterminateCheckBoxIcon />
                                  </IconButton>
                                  <b style={{ m: 1 }}>
                                    <TextField
                                      type="number"
                                      size="small"
                                      sx={{ width: 100 }}
                                      name="grade_c_100"
                                      value={grade_c_100}
                                      onChange={(e) =>
                                        handleAddBag(
                                          investment_detaila?.investment_details
                                            ?.commodity_id,
                                          "Grade C",
                                          100,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade C",
                                        100,
                                        "+"
                                      )
                                    }
                                  >
                                    <AddBoxIcon />
                                  </IconButton>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Next</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      ml: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() => setWhere((prev) => prev + 1)}
                                  />
                                </Typography>
                              </Box>
                            ) : null}
                            {where >= 5 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  m: "auto",
                                }}
                              >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b style={{ marginRight: 1 }}>
                                    Grade C (50 kg)
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade C",
                                        50,
                                        "-"
                                      )
                                    }
                                  >
                                    <IndeterminateCheckBoxIcon />
                                  </IconButton>
                                  <b style={{ m: 1 }}>
                                    <TextField
                                      type="number"
                                      size="small"
                                      sx={{ width: 100 }}
                                      name="grade_b_50"
                                      value={grade_b_50}
                                      onChange={(e) =>
                                        handleAddBag(
                                          investment_detaila?.investment_details
                                            ?.commodity_id,
                                          "Grade C",
                                          50,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </b>
                                  <IconButton
                                    sx={{ m: 1 }}
                                    onClick={() =>
                                      handleAddBag(
                                        investment_detaila?.investment_details
                                          ?.commodity_id,
                                        "Grade C",
                                        50,
                                        "+"
                                      )
                                    }
                                  >
                                    <AddBoxIcon />
                                  </IconButton>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Next</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      ml: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "green",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#fff",
                                      },
                                    }}
                                    onClick={() => setWhere((prev) => prev + 1)}
                                  />
                                </Typography>
                              </Box>
                            ) : null}
                          </Box>

                          {/* <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              m: "auto",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >

                            
                            {investment_detaila?.current_prices?.map((item) => (
                              <div
                                style={{
                                  display: "flex",
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  flexDirection: "column",
                                  margin: 5,
                                  padding: 7,
                                  backgroundColor: "#fff",
                                  borderRadius: 15,
                                }}
                              >
                                <Typography
                                  sx={{ textAlign: "center" }}
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>
                                    {item.Grade === "Grade A" ? (
                                      item.current_price >
                                      investment_detaila?.investment_details
                                        ?.grade_a ? (
                                        <ArrowUpwardIcon
                                          sx={{ color: "green", mr: 1 }}
                                        />
                                      ) : item.current_price <
                                        investment_detaila?.investment_details
                                          ?.grade_a ? (
                                        <ArrowDownwardIcon
                                          sx={{ color: "red", mr: 1 }}
                                        />
                                      ) : (
                                        <BalanceIcon sx={{ mr: 1 }} />
                                      )
                                    ) : item.Grade === "Grade B" ? (
                                      item.current_price >
                                      investment_detaila?.investment_details
                                        ?.grade_b ? (
                                        <ArrowUpwardIcon
                                          sx={{ color: "green", mr: 1 }}
                                        />
                                      ) : item.current_price <
                                        investment_detaila?.investment_details
                                          ?.grade_b ? (
                                        <ArrowDownwardIcon
                                          sx={{ color: "red", mr: 1 }}
                                        />
                                      ) : (
                                        <BalanceIcon sx={{ mr: 1 }} />
                                      )
                                    ) : item.Grade === "Grade C" ? (
                                      item.current_price >
                                      investment_detaila?.investment_details
                                        ?.grade_c ? (
                                        <ArrowUpwardIcon
                                          sx={{ color: "green", mr: 1 }}
                                        />
                                      ) : item.current_price <
                                        investment_detaila?.investment_details
                                          ?.grade_c ? (
                                        <ArrowDownwardIcon
                                          sx={{ color: "red", mr: 1 }}
                                        />
                                      ) : (
                                        <BalanceIcon sx={{ mr: 1 }} />
                                      )
                                    ) : null}
                                  </b>
                                </Typography>
                                <Typography
                                  sx={{ textAlign: "center" }}
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>{item.grade}</b>
                                </Typography>
                                <Typography
                                  sx={{ textAlign: "center" }}
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>
                                    {currencyFormat.format(item.current_price)}
                                    /bag
                                  </b>
                                </Typography>
                                <Divider variant="middle" />
                                {item.bags?.map((bag) => {

                                  const currentBagCount = manipulate.find(
                                    (entry) => entry.grade === item.grade && entry.unit === bag.unit
                                  )?.number_of_bags ?? bag.number_of_bags;
                                  
                                  return (<>
                                    <Typography
                                      sx={{ display: "flex", m: 2 }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b style={{ marginRight: 1 }}>
                                        {bag.unit}kg: {bag.number_of_bags}bags
                                      </b>
                                      <IconButton
                                        sx={{ m: 1 }}
                                        onClick={() => handleRemoveBag(item.grade, bag.unit)}
                                      >
                                        <IndeterminateCheckBoxIcon />
                                      </IconButton>
                                      <b style={{ m: 1 }}>{currentBagCount}</b>
                                      <IconButton
                                        sx={{ m: 1 }}
                                        onClick={() => handleAddBag(item.grade, bag.unit, bag.price)}
                                      >
                                        <AddBoxIcon />
                                      </IconButton>
                                    </Typography>
                                    <Divider variant="middle" />
                                  </>)
                                })}
                              </div>
                            ))}
                          </Box> */}
                        </>
                      ) : null}
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          p: 2,
                          m: 1,
                          borderRadius: 5,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Amount Paid:</b>{" "}
                          <b style={{ color: "#260701", fontSize: 15 }}>
                            {currencyFormat.format(
                              investment_detaila?.investment_details
                                ?.expected_income -
                                investment_detaila?.investment_details
                                  ?.amount_left
                            )}
                          </b>
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          p: 2,
                          m: 1,
                          borderRadius: 5,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Amount left:</b>{" "}
                          <b style={{ color: "#260701", fontSize: 15 }}>
                            {currencyFormat.format(
                              investment_detaila?.investment_details
                                ?.amount_left
                            )}
                          </b>
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        m: 1,
                        overflowX: "auto",
                        maxWidth: 1500,
                        maxHeight: 600,
                        "&::-webkit-scrollbar": {
                          height: "7px",
                          width: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Date</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Amount Paid</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Paid from</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Narration</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Amount left</b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {investment_detaila?.repayments?.map((row) => (
                            <TableRow
                              key={row.transaction_id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                              }}
                            >
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>
                                    {formatDateToYearMonthDay(
                                      new Date(row.date)
                                    )}
                                  </b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.amount)}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.account_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.narration}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.balance)}</b>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={open_modal}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="h4"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Investor Info</b>
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  name="investor_name"
                  label="Investor name"
                  type="text"
                  size="small"
                  fullWidth
                  value={formik.values.investor_name}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  name="company"
                  label="Company name"
                  type="text"
                  size="small"
                  fullWidth
                  value={formik.values.company}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  name="email"
                  label="Investor email"
                  type="text"
                  size="small"
                  fullWidth
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  name="phone"
                  label="Investor Contact number"
                  type="text"
                  size="small"
                  fullWidth
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={[
                    { id: 1, value: "Single cooperative investor" },
                    { id: 2, value: "Multiple cooperative investor" },
                  ]}
                  sx={{ width: 350 }}
                  getOptionLabel={(option) => option.value}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(event, value) => {
                    if (value) {
                      formik.setFieldValue("type", value.value);
                    } else {
                      null;
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      onBlur={formik.handleBlur}
                      error={formik.touched.type && Boolean(formik.errors.type)}
                      helperText={formik.touched.type && formik.errors.type}
                      {...params}
                      size="small"
                      label="Investor Type"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                {image ? (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Avatar
                      sx={{ height: 150, width: 150 }}
                      alt={fileName}
                      src={image}
                    />
                    <IconButton
                      onClick={() => {
                        setFileName("No selected File");
                        setImage(null);
                        formik.setFieldValue("photo", null);
                      }}
                    >
                      <CancelIcon color="error" />
                    </IconButton>
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} md={12}>
                <Button
                  size="small"
                  sx={{
                    m: 1,
                    borderRadius: 2,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#2b2d42",
                    minWidth: 0,
                    "&:hover": {
                      boxShadow:
                        "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                  variant="contained"
                  color="success"
                  onClick={handleButtonClickAct}
                >
                  Upload Company logo or Investor profile photo
                </Button>
                <input
                  name="doc"
                  id="doc"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </Grid>
              <Grid item xs={12} md={9}></Grid>
              <Grid sx={{ display: "flex" }} item xs={12} md={3}>
                <Chip
                  size="small"
                  disabled={loading}
                  label={
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Cancel</b>
                    </Typography>
                  }
                  sx={{
                    borderRadius: 2,
                    m: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "darkred",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                    },
                  }}
                  onClick={closeModal}
                />
                <Chip
                  size="small"
                  label={
                    loading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Finish</b>
                      </Typography>
                    )
                  }
                  sx={{
                    borderRadius: 2,
                    m: 1,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "green",
                    color: "#fff",
                    "&:hover": {
                      boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "#14213d",
                    },
                  }}
                  onClick={formik.handleSubmit}
                />
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </LocalizationProvider>
    </>
  );
};

const PrettoSlider = styled(Slider)({
  color: "#52af77",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#52af77",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

const Trading = ({ id, name }) => {
  const [all_vendors, setAll_vendors] = useState([]);
  const [trade_records, setTrade_records] = useState([]);
  const [vending, setVending] = useState(false);
  const [now_vendor, setNow_vendor] = useState(null);
  const [one_vendor, setOne_vendor] = useState([]);
  const [edit_vendor, setEdit_vendor] = useState(false);
  const [commodities, setCommodities] = useState([]);
  const [one_commodity, setOne_commodity] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [one_warehouse, setOne_warehouse] = useState(null);
  const [warehouse_details, setWarehouse_details] = useState([]);
  const [acts, setActs] = useState([]);
  const [acts_done, setActs_done] = useState(false);
  const [picked_bags, setPicked_bags] = useState(0);
  const [one_grade, setOne_grade] = useState("");
  const [one_unit, setOne_unit] = useState(null);
  const [calc_price, setCalc_price] = useState(null);
  const navigate = useNavigate();
  const [open_modal_print, setOpen_modal_print] = useState(false);
  const [details_print, setDetails_print] = useState({});

  const printRefer = React.useRef();

  const handlePrinter = async () => {
    const element = printRefer.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("TradeInvoice.pdf");
  };

  const style_print = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "95vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
      height: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const printReceipt = (data) => {
    setDetails_print(data);
    setOpen_modal_print(true);
  };

  const closeModalReceipt = () => {
    setOpen_modal_print(false);
  };

  const visitHouse = (ware_id, name_warehouse, row) => {
    navigate("/warehouse", {
      state: {
        id: ware_id,
        name: name_warehouse,
        society: name,
        society_id: id,
        cash_worth: 0,
      },
    });
  };

  const reset = () => {
    setOne_commodity(null);
    setOne_warehouse(null);
    setActs([]);
    setActs_done(false);
    setPicked_bags(0);
    setOne_grade("");
    setOne_unit(null);
    setCalc_price(null);
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  function formatDateToYearMonthDayTime(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${day}${suffix} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
  }

  const editVendor = () => {
    setEdit_vendor(true);
    formik.setFieldValue("vendor_name", one_vendor?.vendor_name);
    formik.setFieldValue("society_id", id);
    formik.setFieldValue("email", one_vendor?.email);
    formik.setFieldValue("phone", one_vendor?.phone);
    setVending(true);
  };

  const fetch_com = () => {
    api
      .get(`/commodity/type/commodities/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCommodities(response.data?.Commodities);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetch_vendors = () => {
    api
      .get(`/investors/get/vendors/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAll_vendors(response.data?.data);
        setTrade_records(response.data?.trade_data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_vendors();
    fetch_com();
  }, []);

  const formik = useFormik({
    initialValues: {
      vendor_name: "",
      society_id: id,
      email: "",
      phone: "",
      photo: null,
    },
    onSubmit: (values) => {
      const data = new FormData();
      data.append("vendor_name", values.vendor_name);
      data.append("society_id", values.society_id);
      data.append("email", values.email);
      data.append("phone", values.phone);
      data.append("photo", values.photo);
      data.append("vendor_id", edit_vendor ? one_vendor?.id : 0);

      api
        .post("/investors/create/vendor", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik.handleReset();
          fetch_vendors();
          setVending(false);
          if (edit_vendor) {
            vendor_details();
            setEdit_vendor(false);
          } else {
            setNow_vendor(null);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  });

  const vendor_details = () => {
    api
      .get(`/investors/get/one/vendor/${now_vendor}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setOne_vendor(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (now_vendor) {
      vendor_details();
    }
  }, [now_vendor]);

  const get_warehouses = () => {
    const data = new FormData();
    data.append("society_id", id);
    data.append("commodity_id", one_commodity);

    api
      .post("/investors/get/warehouse/with/commodities", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setWarehouses(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (one_commodity) {
      get_warehouses();
    }
  }, [one_commodity]);

  const get_warehouse_details = () => {
    const feed = new FormData();
    feed.append("commodity_acc", one_warehouse);
    feed.append("commodity_id", one_commodity);

    api
      .post("/account/commodity/info/in/warehouse", feed, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setWarehouse_details(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (one_warehouse) {
      get_warehouse_details();
    }
  }, [one_warehouse]);

  const get_specifics = () => {
    const info = new FormData();
    info.append("warehouse_id", one_warehouse);
    info.append("commodity_id", one_commodity);
    info.append("grade", one_grade);
    info.append("unit", one_unit);

    toast.promise(
      api.post("/investors/get/warehouse/commodities", info, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Calculating...",
        success: (response) => {
          setActs(response.data);
          setActs_done(true);
          return "Done";
        },
        error: (error) => {
          console.log(error);

          return "An error occurred, Please try again";
        },
      }
    );
  };

  useEffect(() => {
    if (one_unit) {
      get_specifics();
    }
  }, [one_unit]);

  const confirm = () => {
    const info = new FormData();
    info.append("warehouse_id", one_warehouse);
    info.append("commodity_id", one_commodity);
    info.append("grade", one_grade);
    info.append("unit", one_unit);
    info.append("bags", picked_bags);

    toast.promise(
      api.post("/investors/get/warehouse/commodities/calculate", info, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Calculating...",
        success: (response) => {
          setCalc_price(response.data?.price);
          return "Done";
        },
        error: (error) => {
          console.log(error);

          return "An error occurred, Please try again";
        },
      }
    );
  };

  const complete_deal = () => {
    const data = new FormData();
    data.append("commodity_id", one_commodity);
    data.append("warehouse_id", one_warehouse);
    data.append("grade", one_grade);
    data.append("unit", one_unit);
    data.append("bags", picked_bags);
    data.append("price", calc_price);
    data.append("vendor_id", one_vendor.id);
    data.append("society_id", id);

    toast.promise(
      api.post("/investors/complete/trade/deal", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Finishing deal...",
        success: (response) => {
          reset();
          fetch_vendors();
          return response.data;
        },
        error: (error) => {
          console.log(error);
          return "An error occurred, Please try again";
        },
      }
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Ittem>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Vendors</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <Chip
                    variant="outlined"
                    size="small"
                    label={vending ? "All Vendors" : "New Vendor"}
                    onClick={() => setVending((prev) => !prev)}
                  />
                </Typography>
              </Box>
              <Divider variant="middle" sx={{ my: 1 }} />
              {vending ? (
                <Box>
                  <Typography
                    variant="h5"
                    sx={{ mb: 2 }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      {edit_vendor ? "Edit Vendor Details" : "Add New Vendor."}
                    </b>
                  </Typography>

                  <TextField
                    helperText={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Full Name/ Company Name</b>
                      </Typography>
                    }
                    size="small"
                    required
                    fullWidth
                    name="vendor_name"
                    value={formik.values.vendor_name}
                    onChange={formik.handleChange}
                  />

                  <TextField
                    helperText={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Email (optional)</b>
                      </Typography>
                    }
                    size="small"
                    fullWidth
                    type="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                  <TextField
                    helperText={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Phone (optional)</b>
                      </Typography>
                    }
                    size="small"
                    fullWidth
                    name="phone"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                  />

                  <Box sx={{ display: "flex" }}>
                    <Chip
                      size="medium"
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Cancel</b>
                        </Typography>
                      }
                      sx={{
                        borderRadius: 2,
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "red",
                        color: "#000",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                          color: "#fff",
                        },
                      }}
                      onClick={() => {
                        formik.handleReset();
                        setVending(false);
                      }}
                    />
                    <Chip
                      size="medium"
                      disabled={formik.isSubmitting}
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Add</b>
                        </Typography>
                      }
                      sx={{
                        borderRadius: 2,
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "green",
                        color: "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                          color: "#fff",
                        },
                      }}
                      onClick={formik.handleSubmit}
                    />
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  {all_vendors && all_vendors[0] ? (
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                    >
                      {all_vendors &&
                        all_vendors.map((vend) => (
                          <>
                            <ListItem
                              alignItems="flex-start"
                              onClick={() =>
                                setNow_vendor(
                                  now_vendor === vend.id ? null : vend.id
                                )
                              }
                              sx={{
                                color:
                                  now_vendor === vend.id ? "Highlight" : null,
                                cursor: "pointer",
                              }}
                              secondaryAction={
                                <IconButton edge="end" aria-label="comments">
                                  {vend.id === now_vendor ? (
                                    <CheckCircle color="success" />
                                  ) : null}
                                </IconButton>
                              }
                            >
                              <ListItemText
                                primary={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{vend.vendor_name}</b>
                                  </Typography>
                                }
                                secondary={
                                  <Box sx={{ display: "block" }}>
                                    <div>
                                      <Typography
                                        sx={{ display: "inline" }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                      >
                                        <b>{vend.phone}</b>
                                      </Typography>
                                    </div>
                                    <div>
                                      <Typography
                                        sx={{ display: "inline" }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                      >
                                        <b>{vend.email}</b>
                                      </Typography>
                                    </div>
                                  </Box>
                                }
                              />
                            </ListItem>
                            <Divider variant="middle" />
                          </>
                        ))}
                    </List>
                  ) : (
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <p>
                        No Vendors registered.{" "}
                        <b
                          style={{ color: "blue", cursor: "pointer" }}
                          onClick={() => setVending(true)}
                        >
                          Add Vendor
                        </b>
                      </p>
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          </Ittem>
        </Grid>

        <Grid item xs={12} md={8}>
          <Ittem>
            {now_vendor ? (
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography
                    variant="h4"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{one_vendor?.vendor_name}</b>
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Ittem>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography
                        variant="h6"
                        sx={{ textAlign: "center", mr: "auto" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Details</b>
                      </Typography>
                      <Typography
                        onClick={editVendor}
                        sx={{ color: "blue", cursor: "pointer" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Edit</b>
                      </Typography>
                    </Box>
                    <Divider variant="middle" sx={{ my: 1 }} />

                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Name: {one_vendor?.vendor_name}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Email: {one_vendor?.email}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Phone: {one_vendor?.phone}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>
                        Date Registered:{" "}
                        {one_vendor?.date_added
                          ? formatDateToYearMonthDayTime(
                              new Date(one_vendor?.date_added)
                            )
                          : ""}
                      </b>
                    </Typography>
                  </Ittem>
                </Grid>

                <Grid item xs={12} md={8}>
                  <Ittem>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Typography
                          sx={{ textAlign: "center" }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Trade</b>
                        </Typography>
                        <Divider />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <Box display="flex">
                          {commodities ? (
                            commodities.map((item) => (
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{item.commodity}</b>
                                  </Typography>
                                }
                                size="small"
                                variant={
                                  one_commodity && one_commodity === item.id
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    one_commodity && one_commodity === item.id
                                      ? "#fff"
                                      : "#344e41",
                                  color:
                                    one_commodity && one_commodity === item.id
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setOne_commodity(item.id)}
                              />
                            ))
                          ) : (
                            <Typography variant="subtitle" fontStyle="Italic">
                              Commodities in Society will appear here there is
                              any
                            </Typography>
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={4.5}>
                        {one_commodity ? (
                          <>
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Select warehouse (if no warehouses are
                                displayed, check if there are some existing in
                                the society and deals in the selected commodity)
                              </b>
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                ml: "auto",
                              }}
                            >
                              <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={warehouses}
                                sx={{ width: 250 }}
                                getOptionLabel={(option) => option.warehouse}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                onChange={(event, value) =>
                                  setOne_warehouse(value.id)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                    helperText="Select warehouse"
                                  />
                                )}
                              />
                              <Tooltip title="Refresh">
                                <IconButton
                                  onClick={() => {
                                    setOne_warehouse(null);
                                    vendor_details();
                                    get_warehouses();
                                  }}
                                >
                                  <CachedRoundedIcon sx={{ color: "black" }} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </>
                        ) : null}
                      </Grid>

                      <Grid item xs={12} md={0.5}>
                        <Divider orientation="vertical" />
                      </Grid>

                      <Grid item xs={12} md={7}>
                        {one_warehouse ? (
                          <>
                            <Ittem>
                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Grade A</b>
                                    </Typography>
                                  }
                                  variant={
                                    one_grade && one_grade === "Grade A"
                                      ? "filled"
                                      : "outlined"
                                  }
                                  sx={{
                                    m: "1.5px",
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                      one_grade && one_grade === "Grade A"
                                        ? "#fff"
                                        : "#344e41",
                                    color:
                                      one_grade && one_grade === "Grade A"
                                        ? "#000"
                                        : "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#000",
                                    },
                                  }}
                                  onClick={() => {
                                    if (one_grade === "Grade A") {
                                      setOne_grade("");
                                      setOne_unit(null);
                                    } else {
                                      setOne_grade("Grade A");
                                    }
                                  }}
                                />
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Grade B</b>
                                    </Typography>
                                  }
                                  variant={
                                    one_grade && one_grade === "Grade B"
                                      ? "filled"
                                      : "outlined"
                                  }
                                  sx={{
                                    m: "1.5px",
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                      one_grade && one_grade === "Grade B"
                                        ? "#fff"
                                        : "#344e41",
                                    color:
                                      one_grade && one_grade === "Grade B"
                                        ? "#000"
                                        : "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#000",
                                    },
                                  }}
                                  onClick={() => {
                                    if (one_grade === "Grade B") {
                                      setOne_grade("");
                                      setOne_unit(null);
                                    } else {
                                      setOne_grade("Grade B");
                                    }
                                  }}
                                />
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Grade C</b>
                                    </Typography>
                                  }
                                  variant={
                                    one_grade && one_grade === "Grade C"
                                      ? "filled"
                                      : "outlined"
                                  }
                                  sx={{
                                    m: "1.5px",
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                      one_grade && one_grade === "Grade C"
                                        ? "#fff"
                                        : "#344e41",
                                    color:
                                      one_grade && one_grade === "Grade C"
                                        ? "#000"
                                        : "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#000",
                                    },
                                  }}
                                  onClick={() => {
                                    if (one_grade === "Grade C") {
                                      setOne_grade("");
                                      setOne_unit(null);
                                    } else {
                                      setOne_grade("Grade C");
                                    }
                                  }}
                                />
                              </Box>
                              {one_grade ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>100kg</b>
                                      </Typography>
                                    }
                                    variant={
                                      one_unit && one_unit === 100
                                        ? "filled"
                                        : "outlined"
                                    }
                                    sx={{
                                      m: 1,
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor:
                                        one_unit && one_unit === 100
                                          ? "#fff"
                                          : "#344e41",
                                      color:
                                        one_unit && one_unit === 100
                                          ? "#000"
                                          : "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={() => {
                                      if (one_unit === 100) {
                                        setOne_unit(null);
                                      } else {
                                        setOne_unit(100);
                                      }
                                    }}
                                  />
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>50kg</b>
                                      </Typography>
                                    }
                                    variant={
                                      one_unit && one_unit === 50
                                        ? "filled"
                                        : "outlined"
                                    }
                                    sx={{
                                      m: 1,
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor:
                                        one_unit && one_unit === 50
                                          ? "#fff"
                                          : "#344e41",
                                      color:
                                        one_unit && one_unit === 50
                                          ? "#000"
                                          : "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={() => {
                                      if (one_unit === 50) {
                                        setOne_unit(null);
                                      } else {
                                        setOne_unit(50);
                                      }
                                    }}
                                  />
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>90kg</b>
                                      </Typography>
                                    }
                                    variant={
                                      one_unit && one_unit === 90
                                        ? "filled"
                                        : "outlined"
                                    }
                                    sx={{
                                      m: 1,
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor:
                                        one_unit && one_unit === 90
                                          ? "#fff"
                                          : "#344e41",
                                      color:
                                        one_unit && one_unit === 90
                                          ? "#000"
                                          : "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={() => {
                                      if (one_unit === 90) {
                                        setOne_unit(null);
                                      } else {
                                        setOne_unit(90);
                                      }
                                    }}
                                  />
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>84kg</b>
                                      </Typography>
                                    }
                                    variant={
                                      one_unit && one_unit === 84
                                        ? "filled"
                                        : "outlined"
                                    }
                                    sx={{
                                      m: 1,
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor:
                                        one_unit && one_unit === 84
                                          ? "#fff"
                                          : "#344e41",
                                      color:
                                        one_unit && one_unit === 84
                                          ? "#000"
                                          : "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={() => {
                                      if (one_unit === 84) {
                                        setOne_unit(null);
                                      } else {
                                        setOne_unit(84);
                                      }
                                    }}
                                  />
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>130kg</b>
                                      </Typography>
                                    }
                                    variant={
                                      one_unit && one_unit === 130
                                        ? "filled"
                                        : "outlined"
                                    }
                                    sx={{
                                      m: 1,
                                      borderRadius: 2,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor:
                                        one_unit && one_unit === 130
                                          ? "#fff"
                                          : "#344e41",
                                      color:
                                        one_unit && one_unit === 130
                                          ? "#000"
                                          : "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                        color: "#000",
                                      },
                                    }}
                                    onClick={() => {
                                      if (one_unit === 130) {
                                        setOne_unit(null);
                                      } else {
                                        setOne_unit(130);
                                      }
                                    }}
                                  />
                                </Box>
                              ) : null}
                            </Ittem>

                            {acts_done ? (
                              <Box sx={{ mt: 3 }}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>
                                    Total number of Bags:{" "}
                                    {acts?.total_bags ? acts?.total_bags : 0}
                                  </b>
                                  <br />
                                  <b>
                                    Value at time of storage:{" "}
                                    {currencyFormat.format(
                                      acts?.total_cash_value
                                    )}
                                  </b>
                                </Typography>

                                <PrettoSlider
                                  valueLabelDisplay="auto"
                                  aria-label="pretto slider"
                                  value={picked_bags}
                                  onChange={(e) =>
                                    setPicked_bags(e.target.value)
                                  }
                                  max={acts?.total_bags}
                                  disabled={acts?.total_bags ? false : true}
                                />

                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Picking {picked_bags} bags</b>
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Confirm</b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      m: 1,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "#2b2d42",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={confirm}
                                  />
                                </Typography>

                                {calc_price ? (
                                  <Box>
                                    <Typography
                                      sx={{ textAlign: "center" }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>
                                        Calculated Price:{" "}
                                        {currencyFormat.format(calc_price)}
                                      </b>
                                    </Typography>

                                    <Chip
                                      size="small"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Complete Deal</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "#2b2d42",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={complete_deal}
                                    />
                                  </Box>
                                ) : null}
                              </Box>
                            ) : null}
                          </>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Ittem>
                </Grid>
              </Grid>
            ) : (
              <Typography
                sx={{ textAlign: "center" }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b style={{ cursor: "pointer" }}>Select Vendor</b>
              </Typography>
            )}
          </Ittem>
        </Grid>

        <Grid item xs={12} md={12}>
          <Ittem>
            <Typography
              sx={{ textAlign: "center" }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b style={{ cursor: "pointer" }}>Trade Records</b>
            </Typography>
            <Box
              sx={{
                m: 1,
                overflow: "auto",
                minWidth: 1250,
                maxHeight: 600,
                "&::-webkit-scrollbar": {
                  height: "7px",
                  width: "7px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Date</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Vendor</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Commodity</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Bags Count</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Grade</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Unit</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Amount</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Pick Up Point</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Warehouse</b>
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Status</b>
                      </Typography>{" "}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {trade_records &&
                    trade_records.map((row) => (
                      <TableRow
                        key={row.trade_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {formatDateToYearMonthDayTime(
                                new Date(row.trade_date)
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.vendor_name}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.commodity}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.bags}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.grade}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.unit}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{currencyFormat.format(row.price)}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.pick_up_point}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography
                            onClick={() =>
                              visitHouse(row.warehouse_id, row.warehouse, row)
                            }
                            sx={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>{row.warehouse}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.trade_status}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Box sx={{ display: "flex", flexDirection: "row" }}>
                            <Chip
                              size="small"
                              label={
                                <Typography
                                  variant="subtitle"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>Print Invoice</b>
                                </Typography>
                              }
                              sx={{
                                borderRadius: 2,
                                m: "5px",
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "green",
                                color: "#fff",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                },
                              }}
                              onClick={() => printReceipt(row)}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>

              <Modal
                open={open_modal_print}
                onClose={closeModalReceipt}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style_print}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Chip
                          size="medium"
                          label={
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Print</b>
                            </Typography>
                          }
                          sx={{
                            borderRadius: 2,
                            mr: "auto",
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "orange",
                            color: "#000",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                              color: "#fff",
                            },
                          }}
                          onClick={handlePrinter}
                        />
                        <Chip
                          size="medium"
                          label={
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Close</b>
                            </Typography>
                          }
                          sx={{
                            borderRadius: 2,
                            ml: "auto",
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "red",
                            color: "#fff",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                              color: "#fff",
                            },
                          }}
                          onClick={closeModalReceipt}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Grid container spacing={2} ref={printRefer}>
                        <Grid item xs={12} md={12}>
                          <Typography
                            variant="subtitle"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            textAlign="center"
                            sx={{ color: "grey", mb: 3, ml: "43%" }}
                          >
                            <b>~ The Cooperative ~</b>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Avatar
                            src={KPeeLogo}
                            alt="KPee logo"
                            sx={{ width: 120, height: 120, m: "auto" }}
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Typography
                            variant="h3"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            sx={{ textAlign: "center" }}
                          >
                            <b>{name}</b>
                          </Typography>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>{formatDateToYearMonthDayTime(new Date())}</b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography
                            sx={{
                              textAlign: "center",
                              textDecoration: "underline",
                            }}
                            variant="h4"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Vendor</b>
                          </Typography>

                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Name: {details_print?.vendor_name}</b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Email: {details_print?.email}</b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Phone Contact: {details_print?.phone}</b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography
                            sx={{
                              textAlign: "center",
                              textDecoration: "underline",
                            }}
                            variant="h4"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Trade Deal</b>
                          </Typography>

                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Commodity: {details_print?.commodity}</b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Number of Bags:{" "}
                              {currencyFormat.format(details_print?.bags)}
                            </b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Commodity Grade: {details_print?.grade}</b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Commodity Bag Unit: {details_print?.unit}kg</b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Pick Up Point:{" "}
                              {details_print?.pick_up_point ===
                              "Local Warehouse"
                                ? details_print?.warehouse
                                : "Main Warehouse"}
                            </b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Pick Up Date:{" "}
                              {details_print?.pick_up_date
                                ? formatDateToYearMonthDayTime(
                                    new Date(details_print?.pick_up_date)
                                  )
                                : "Not Confirmed"}
                            </b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Amount Paid:{" "}
                              {currencyFormat.format(details_print?.price)}
                            </b>
                          </Typography>
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Selling Bag Price(single):{" "}
                              {currencyFormat.format(
                                details_print?.price / details_print?.bags
                              )}
                            </b>
                          </Typography>
                          {/* <Divider variant="middle" /> */}
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography
                            variant="h5"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Deal Status: {details_print?.trade_status}</b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Typography
                            sx={{ textAlign: "center", mt: 5 }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>It was a pleasure doing business with you.</b>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </Box>
          </Ittem>
        </Grid>
      </Grid>
    </>
  );
};

const KindAccount = () => {
  const [theme, colorMode] = useMode();
  const location = useLocation();
  const [isSidebar, setIsSidebar] = useState(true);
  const society_id = location.state && location.state.society_id;
  const name = location.state && location.state.name;
  const [value, setValue] = React.useState(0);
  const { permissions } = useContext(AuthContext);
  const [society_name, setSociety_name] = useState("Society");

  useEffect(() => {
    api
      .get(`/investors/society/get/name/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setSociety_name(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", m: 1 }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>{society_name}</b>
            </Typography>
          </Box>
          <Box>
            <Tabs
              variant="fullWidth"
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{
                backgroundColor: "#e9ecef",
                borderRadius: 7,
                boxShadow:
                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#f8f9fa",
                },
              }}
            >
              <Tab
                label={
                  <b
                    style={{
                      color: "#2b2d42",
                      fontFamily:
                        "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                    }}
                  >
                    Reconciliations
                  </b>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <b
                    style={{
                      color: "#2b2d42",
                      fontFamily:
                        "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                    }}
                  >
                    Main Wallet
                  </b>
                }
                {...a11yProps(1)}
              />

              {permissions && permissions.view_bank_accounts === true ? (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Other Accounts
                    </b>
                  }
                  {...a11yProps(2)}
                />
              ) : null}
              {permissions && permissions.view_bank_accounts === true ? (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Expenditures
                    </b>
                  }
                  {...a11yProps(3)}
                />
              ) : (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Expenditures
                    </b>
                  }
                  {...a11yProps(2)}
                />
              )}
              {permissions && permissions.view_bank_accounts === true ? (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Investments
                    </b>
                  }
                  {...a11yProps(4)}
                />
              ) : (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Investments
                    </b>
                  }
                  {...a11yProps(3)}
                />
              )}
              {permissions && permissions.view_bank_accounts === true ? (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Trading
                    </b>
                  }
                  {...a11yProps(5)}
                />
              ) : (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Trading
                    </b>
                  }
                  {...a11yProps(4)}
                />
              )}
              {permissions && permissions.view_bank_accounts === true ? (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Society Warehouse
                    </b>
                  }
                  {...a11yProps(6)}
                />
              ) : (
                <Tab
                  label={
                    <b
                      style={{
                        color: "#2b2d42",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Society Warehouse
                    </b>
                  }
                  {...a11yProps(5)}
                />
              )}
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <AccountReconciliation id={society_id} name={name} dash={false} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <MainAccounts society_id={society_id} name={name} />
            </CustomTabPanel>
            {permissions && permissions.view_bank_accounts === true ? (
              <CustomTabPanel value={value} index={2}>
                <BankAccounts id={society_id} name={name} />
              </CustomTabPanel>
            ) : null}

            {permissions && permissions.view_bank_accounts === true ? (
              <CustomTabPanel value={value} index={3}>
                <LedgersAccount id={society_id} name={name} />
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={value} index={2}>
                <LedgersAccount id={society_id} name={name} />
              </CustomTabPanel>
            )}

            {permissions && permissions.view_bank_accounts === true ? (
              <CustomTabPanel value={value} index={4}>
                <Investments id={society_id} name={name} />
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={value} index={3}>
                <Investments id={society_id} name={name} />
              </CustomTabPanel>
            )}

            {permissions && permissions.view_bank_accounts === true ? (
              <CustomTabPanel value={value} index={5}>
                <Trading id={society_id} name={name} />
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={value} index={4}>
                <Trading id={society_id} name={name} />
              </CustomTabPanel>
            )}
            {permissions && permissions.view_bank_accounts === true ? (
              <CustomTabPanel value={value} index={6}>
                <SocietyWarehouse id={society_id} name={name} />
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={value} index={5}>
                <SocietyWarehouse id={society_id} name={name} />
              </CustomTabPanel>
            )}
          </Box>
        </Box>
      </main>
    </div>
  );
};
export default KindAccount;
